(function (angular, app) {
    'use strict';

    var TIMES_OPTIONS = {
        LOCAL_DELIVERY: 'Local Delivery',
        SHIPPING_SERVICE: 'Shipping'
    };

    var MINUTE_IN_MS = 1000 * 60,
        DAY_IN_MS = MINUTE_IN_MS * 60 * 24;

    app
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider.state('app.checkout.details', {
                url: '/details',
                metaTags: {
                    title: ['$filter', function ($filter) {
                        return ($filter('translate')('Checkout'));
                    }]
                },
                views: {
                    checkoutTab: {
                        templateUrl: 'template/views/checkout/details/index.html',
                        controller: 'CheckoutDetailsTabCtrl as detailsCtrl',
                        resolve: {
                            cartSaved: ['$rootScope', '$q', 'Cart', function ($rootScope, $q, Cart) {
                                if (Cart.sendingSucceeded) {
                                    return;
                                }

                                return new $q(function (resolve) {
                                    var listener = $rootScope.$on('cart.update.complete', function () {
                                        listener();
                                        resolve();
                                    });
                                });
                            }],
                            deliveryMethods: ['SpDeliveryTimesService', 'SP_SERVICES', function (spDeliveryTimesService, SP_SERVICES) {
                                return spDeliveryTimesService.init().then(function (deliveryMethods) {
                                    var options = [];

                                    /**
                                     * Set delivery method option
                                     */
                                    if (deliveryMethods[SP_SERVICES.DELIVERY_TYPES.DELIVERY]) {
                                        options.push({
                                            image: 'https://d226b0iufwcjmj.cloudfront.net/global/frontend-icons/icon-delivery-tab-grey.png',
                                            selectedImage: 'https://d226b0iufwcjmj.cloudfront.net/global/frontend-icons/icon-delivery-tab-white.png',
                                            label: 'Delivery',
                                            value: {
                                                id: SP_SERVICES.DELIVERY_TYPES.DELIVERY
                                            }
                                        });
                                    }

                                    /**
                                     * Set pickup method option
                                     */
                                    if (deliveryMethods[SP_SERVICES.DELIVERY_TYPES.PICKUP]) {
                                        options.push({
                                            image: 'https://d226b0iufwcjmj.cloudfront.net/global/frontend-icons/icon-pickup-tab-grey.png',
                                            selectedImage: 'https://d226b0iufwcjmj.cloudfront.net/global/frontend-icons/icon-pickup-tab-white.png',
                                            label: 'Pick Up',
                                            value: {
                                                id: SP_SERVICES.DELIVERY_TYPES.PICKUP
                                            }
                                        });
                                    }

                                    return {
                                        options: options,
                                        paymentMethods: deliveryMethods
                                    };
                                });
                            }],
                            zipCodeLimitLength:['Config', function (config) {
                                var _US_ZIP_CODE_LENGTH = 5;
                                return config.retailer.currencyCode === 'USD' ? _US_ZIP_CODE_LENGTH : undefined;
                            }],
                            AddressFormService: ['AddressFormService', function(AddressFormService) {
                                return AddressFormService.initAddressFormService();
                            }],
                        }
                    }
                }
            });
        }])
        .controller('CheckoutDetailsTabCtrl', [
            '$scope', '$rootScope', '$state', '$filter', '$timeout', '$q',
            'Config', 'Util', 'Api', 'User', 'Dialog', 'Cart', 'SpDeliveryTimesService', 'SpDeliveryAreasService',
            'ChooseAreaDialog', 'LocalStorage', 'deliveryMethods', 'ShippingTermsPopup', 'AddressFormService',
            'SeniorCitizenVerificationDialog', 'PHONE_TYPES', 'DELIVERY_TIMES_TYPES', 'SUBSTITUTE_PREFERENCES',
            'SP_SERVICES', 'CITY_TYPES', 'HOUSE_ENTRIES', 'CHARGE_SPECIALS_CALCULATION_TIME', 'DELIVERY_AREA_METHODS_PRECISION',
            'DataLayer', 'AddressService', 'GOOGLE_MAP_ADDRESS_TYPES', 'Dialog', 'FILTER_ADDRESS_MODE', 'GoogleMapService', 'zipCodeLimitLength', 'LANGUAGES', 'Orders',
            function ($scope, $rootScope, $state, $filter, $timeout, $q,
                config, util, api, user, dialog, cart, spDeliveryTimesService, SpDeliveryAreasService,
                ChooseAreaDialog, localStorageService, deliveryMethods, ShippingTermsPopup, AddressFormService,
                SeniorCitizenVerificationDialog, PHONE_TYPES, DELIVERY_TIMES_TYPES, SUBSTITUTE_PREFERENCES,
                SP_SERVICES, CITY_TYPES, HOUSE_ENTRIES, CHARGE_SPECIALS_CALCULATION_TIME,
                DELIVERY_AREA_METHODS_PRECISION, DataLayer, AddressService, GOOGLE_MAP_ADDRESS_TYPES, Dialog, FILTER_ADDRESS_MODE, GoogleMapService, zipCodeLimitLength, LANGUAGES, Orders) {
                var detailsCtrl = this,
                    checkoutCtrl = $scope.checkoutCtrl,
                    userEditCtrl = $scope.userEditCtrl,
                    dateFilter = $filter('date'),
                    translateFilter = $filter('translate'),
                    _getCitiesPromise,
                    _timesInactivityTimeout,
                    _houseNumberRegExp = new RegExp(/^[0-9 \-]+$/),
                    _wasText1HouseNumberShown = false,
                    _ADDRESS_TYPE_MAP = {
                        city: 'city',
                        text1: 'address',
                        zipCode: 'zipCode'

                    },
                    _FILTERING_MODES = {
                        NONE: 'None',
                        CITY: 'City',
                        ZIP_CODE: 'ZipCode',
                        STREET: 'Street'
                    },
                    _addressComponents = ['city', 'street', 'houseNumber', 'text1', 'zipCode'],
                    INVALID_SALES_TYPES = {
                        SELL_DATES: 'sellDates',
                        SPECIAL: 'special',
                        COUPON: 'coupon',
                        CATERING_PRODUCT: 'cateringProduct'
                    };

                angular.extend(detailsCtrl, {
                    primaryTitle: primaryTitle,
                    validateAddress: validateAddress,
                    validatePhone: validatePhone,
                    setDeliveryTimes: setDeliveryTimes,
                    onDeliveryMethodChanged: onDeliveryMethodChanged,
                    setDeliveryTimesFromAutocomplete: setDeliveryTimesFromAutocomplete,
                    setDeliveryTimesAfterInactivity: setDeliveryTimesAfterInactivity,
                    getCityAutoCompleteOptions: getCityAutoCompleteOptions,
                    getStreetAutoCompleteOptions: getStreetAutoCompleteOptions,
                    getEntriesAutoComplete: getEntriesAutoComplete,
                    onTimesOptionChange: onTimesOptionChange,
                    onCityChange: onCityChange,
                    onCityBlur: onCityBlur,
                    onCityChosen: onCityChosen,
                    onStreetBlur: onStreetBlur,
                    disabledDeliveryDayChosen: disabledDeliveryDayChosen,
                    changeStore: changeStore,
                    showText1HouseNumberWarning: showText1HouseNumberWarning,
                    validateCountryCode: validateCountryCode,
                    validateAreaCode: validateAreaCode,
                    showSeniorCitizen: showSeniorCitizen,
                    phoneEditMode: phoneEditMode,
                    changeToDeliveryMethod: changeToDeliveryMethod,
                    openAutocompleteAddress: openAutocompleteAddress,
                    formOnClick: formOnClick,
                    filterCountryNames: filterCountryNames,
                    checkingAddressInProgress: false,
                    phoneValidationSubmitted: false,
                    deliveryAreaMethod: config.retailer.deliveryAreaMethod,
                    deliveryMethodOptions: deliveryMethods.options,
                    // TODO remove
                    streetIsRequire: $rootScope.config.retailer.deliveryAreaPrecision !== DELIVERY_AREA_METHODS_PRECISION.CITY_STREET_NOT_REQUIRED,
                    customPhoneRegExp: new RegExp(/^\(?\+?(\d[0-9\)\(-]*)$/),
                    phoneRegExp: new RegExp(/^\(?\+?(\d[\s,\-,(,),,,]*){7,15}$/),
                    customPhoneValidation: config.retailer.customPhoneValidation && config.retailer.customPhoneValidation.isActive,
                    editPhoneMode: false,
                    compiledPhoneNumber: '',
                    //private, but is exposed for override
                    _validateForm: _validateForm,
                    entries: HOUSE_ENTRIES,
                    selectedPickupArea: {},
                    isRunAddressAutoComplete: true,
                    suggestedCities: [],
                    suggestedAddresses: [],
                    isAddressVerificationEnabled: false,
                    addressVerificationText: config.retailer.settings.addressVerificationText ? JSON.parse(config.retailer.settings.addressVerificationText) : {},
                    addressVerificationTextDroppinOff: JSON.parse(config.retailer.settings.addressVerificationTextDroppinOff || '{}'),
                    formErrorCtrl: {
                        city: false,
                        text1: false,
                        zipCode: false
                    },
                    formErrorMessage: '',
                    addressCompletedMethod: 'Manual',
                    backupAddress: {},
                    isGoogleMapDialogOpening: false,
                    zipCodeLimitLength: zipCodeLimitLength,
                    isUseNewAddressesFeature: AddressFormService.isUseNewAddressesFeature,
                    onAddressChange: onAddressChange,
                    onAddressBlur: onAddressBlur,
                    onHouseNumberBlur: onHouseNumberBlur,
                    onAddressChosen: onAddressChosen,
                    getAddressAutoCompleteOptions: getAddressAutoCompleteOptions,
                    onAddressInputKeyDown: onAddressInputKeyDown,
                    openGoogleMapDialog: openGoogleMapDialog,
                    onCountryBlur: onCountryBlur,
                    editUnrecognizedAddress: editUnrecognizedAddress,
                    cancelPinnedAddress: cancelPinnedAddress,
                    onZipCodeBlur: onZipCodeBlur,
                    onZipCodeChange: onZipCodeChange,
                    isShowAddressField: isShowAddressField,
                    isDisableAddressField: isDisableAddressField,
                    isDropPinRequiredStreetAndHouseNumber: isDropPinRequiredStreetAndHouseNumber,
                    editDropPinAddressField: editDropPinAddressField,
                    onDropPinAddressFieldBlur: onDropPinAddressFieldBlur,
                    getAddressFieldLabel: getAddressFieldLabel,
                    getAddressFormFieldSettings: getAddressFormFieldSettings,
                    getDropPinClarifyMessage: getDropPinClarifyMessage,

                    rawCkoutPromotionConfig: null,
                    checkoutPromotionSettings: null,
                });

                checkoutCtrl.nextTab = nextTab;
                checkoutCtrl.isSummaryTab = false;
                checkoutCtrl.detailsData = checkoutCtrl.detailsData || {};
                checkoutCtrl.hasAddressDetails = util.checkAddressFields(checkoutCtrl.detailsData.address);
                checkoutCtrl.countryNames = util.getCountryAutocompleteOptions();
                checkoutCtrl.isUseGMapDeliveryMethod = [SP_SERVICES.DELIVERY_AREA_METHODS.GOOGLE_MAPS, SP_SERVICES.DELIVERY_AREA_METHODS.POLYGON].includes(detailsCtrl.deliveryAreaMethod);
                detailsCtrl.isGMapWithZipCodeProvider = config.retailer.settings.autocompleteAddressField && config.retailer.settings.activeZipProvider && config.retailer.settings.activeZipProvider.name === 'Get Address'
                checkoutCtrl.isZipCodeValid = false;
                checkoutCtrl.dropPinDisableFields = AddressFormService.getDropPinDisableFields();
                checkoutCtrl.getSubstitutePreferenceLabel = getSubstitutePreferenceLabel;

                if (!checkoutCtrl.timesOptions) {
                    _resetTimesOptions();
                }

                function checkIsOnePickupArea() {
                    SpDeliveryAreasService.getAreas().then(function (areas) {
                        var pickupAreas = areas.filter(function (area) {
                            return area.deliveryTypeId == SP_SERVICES.DELIVERY_TYPES.PICKUP;
                        })
                        if (pickupAreas && pickupAreas.length === 1) {
                            detailsCtrl.selectedPickupArea = pickupAreas[0]
                        }
                    });
                }

                ShippingTermsPopup.showWithRedirect();

                config.initPromise.then(function () {
                    var area = config.getBranchArea(),
                        defaultDeliveryMethod = Number(config.retailer.settings.deliveryMethodDefault) || SP_SERVICES.DELIVERY_TYPES.DELIVERY,
                        deliveryMethodId = (checkoutCtrl.detailsData && checkoutCtrl.detailsData.deliveryMethod && checkoutCtrl.detailsData.deliveryMethod.id) || (area && area.deliveryTypeId) || defaultDeliveryMethod;
                    if (deliveryMethodId) {
                        for (var i = 0; i < detailsCtrl.deliveryMethodOptions.length; i++) {
                            if (detailsCtrl.deliveryMethodOptions[i].value.id === deliveryMethodId) {
                                checkoutCtrl.detailsData = checkoutCtrl.detailsData || {};
                                checkoutCtrl.hasAddressDetails = util.checkAddressFields(checkoutCtrl.detailsData.address);
                                checkoutCtrl.detailsData.deliveryMethod = detailsCtrl.deliveryMethodOptions[i].value;
                                break;
                            }
                        }
                    }
                    
                    // Track Address Details Viewed event
                    var isDelivery = deliveryMethodId === SP_SERVICES.DELIVERY_TYPES.DELIVERY;
                    var configuredFields = ['fullname', 'phone']; // Base fields for all delivery methods
                    var requiredFields = ['fullname', 'phone']; // Base required fields for all delivery methods
                    
                    // Add address fields only for delivery (not pickup)
                    if (isDelivery) {
                        // Always include basic address fields for delivery
                        configuredFields.push('street', 'city');
                        requiredFields.push('street', 'city');
                        
                        // Process address form settings
                        var addressFormSettings = util.tryParseJson(config.retailer.settings.addressFormSettings) || {};
                        var addressFields = ['zipCode', 'apartment', 'entrance', 'buildingCode', 'state', 'comments', 'floor'];
                        
                        // Add configured address fields
                        addressFields.forEach(function(fieldName) {
                            var fieldConfig = addressFormSettings[fieldName];
                            if (fieldConfig && fieldConfig.isEnabled) {
                                configuredFields.push(fieldName);
                                if (fieldConfig.isMandatory) {
                                    requiredFields.push(fieldName);
                                }
                            }
                        });
                        
                        // Add house number if separate street/house fields are enabled
                        if (config.retailer.settings.addressFormSeparateStreetHouse === 'true') {
                            var houseNumberConfig = addressFormSettings.houseNumber;
                            if (houseNumberConfig && houseNumberConfig.isEnabled) {
                                configuredFields.push('houseNumber');
                                if (houseNumberConfig.isMandatory) {
                                    requiredFields.push('houseNumber');
                                }
                            }
                        }
                    }
                    
                    // Determine filtering method based on configuration
                    var filteringMethod = SP_SERVICES.MIXPANEL_VALUES.FILTERING_METHOD.NONE;
                    if (config.retailer.settings.enableAddressFiltering) {
                        if (config.retailer.settings.addressFiltering === 2) { // ZIP_CODE mode
                            filteringMethod = SP_SERVICES.MIXPANEL_VALUES.FILTERING_METHOD.ZIP_CODE;
                        } else if (config.retailer.settings.addressFiltering === 1) { // CITY mode
                            filteringMethod = SP_SERVICES.MIXPANEL_VALUES.FILTERING_METHOD.CITY;
                        }
                    }
                    
                    $rootScope.$emit($rootScope.SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_DETAILS_VIEWED, {
                        filteringMethod: isDelivery ? filteringMethod : SP_SERVICES.MIXPANEL_VALUES.FILTERING_METHOD.NONE,
                        dropPinEnabled: isDelivery  && (config.retailer.settings.isGoogleMapDropPinAllow === 'true' || config.retailer.settings.isGoogleMapDropPinAllow === true),
                        configuredFieldsShown: configuredFields,
                        requiredFields: requiredFields,
                        mobileOnePagerCheckout: false // TODO: update after mobile one pager is implemented
                    });

                    // Init substitute preferences
                    _initSubstitutePreferences().then(function (result) {
                        detailsCtrl.substitutePreferences = result.substitutePreferences;
                        detailsCtrl.substitutePreferencesTitle = result.substitutePreferencesTitle;
                        checkoutCtrl.detailsData.substitutePreferences = result.defaultSubstitutePreference;
                    });

                    detailsCtrl.receiptOptions = Object.values($rootScope.RECEIPT_TYPE_ID) || [];
                    detailsCtrl.isReceiptOption = config.retailer.settings.isReceiptOption === 'true';
                    detailsCtrl.receiptDigital = util.tryParseJson(config.retailer.settings.receiptDigital) || {};
                    detailsCtrl.isHiddenBranchName = config.retailer.settings.isHiddenBranchName === 'true';
                    _setReceiptOption();

                    return user.getData();
                }).then(function () {
                    detailsCtrl.isSeniorCitizen = user.data.isSeniorCitizen;

                    if (!checkoutCtrl.detailsData.address) {
                        checkoutCtrl.detailsData.address = {};
                        checkoutCtrl.detailsData.mobilePhone = {};
                        checkoutCtrl.detailsData.deliveryMethod = checkoutCtrl.detailsData.deliveryMethod || detailsCtrl.deliveryMethodOptions[0].value;

                        if (user.data) {
                            AddressFormService.cleanAddressDataBaseOnRetailerConfig(user.data.address);
                            
                            checkoutCtrl.userOrganization = user.data.organization;
                            checkoutCtrl.userLoyaltyClubCardId = user.data.loyaltyClubCardId;
                            checkoutCtrl.userLoyaltyVerificationStatus = user.data.loyaltyVerificationStatus;
                            checkoutCtrl.detailsData.address = user.data.address || {};
                            checkoutCtrl.detailsData.friendlyName = ((user.data.firstName || '') + ' ' + (user.data.lastName || '')).trim() || checkoutCtrl.detailsData.address.friendlyName || '';

                            if (config.isZipCodeArea && config.area && !checkoutCtrl.detailsData.address.zipCode && config.area !== 'Pickup') {
                                checkoutCtrl.detailsData.address.zipCode = config.area;
                            }
                            if (user.data.orderComments && !checkoutCtrl.detailsData.comments) {
                                checkoutCtrl.detailsData.comments = user.data.orderComments;
                            }
                            checkoutCtrl.detailsData.mobilePhone = angular.filterCollection(user.data.phones, function (phone) {
                                return phone.typeVal === PHONE_TYPES.MOBILE;
                            })[0] || {};
                        }

                        _compileCustomValidatedPhone();
                        detailsCtrl.phoneNumber = checkoutCtrl.detailsData.mobilePhone.phoneNumber;

                        if (detailsCtrl.customPhoneValidation) {
                            var phoneValidation = config.retailer.customPhoneValidation
                            if (phoneValidation.countryCodes && phoneValidation.countryCodes.length === 1) {
                                checkoutCtrl.detailsData.mobilePhone.countryCode = phoneValidation.countryCodes[0]
                            }

                            if (phoneValidation.areaCodes && phoneValidation.areaCodes.length === 1) {
                                checkoutCtrl.detailsData.mobilePhone.areaCode = phoneValidation.areaCodes[0]
                            }
                        }

                        var _changeBranchSavedAddress = util.getChangeBranchSavedAddress();
                        if (_changeBranchSavedAddress) {
                            angular.extend(
                                checkoutCtrl.detailsData.address,
                                _changeBranchSavedAddress
                            );
                        }

                        if (config.retailer.settings.staticZipCode) {
                            checkoutCtrl.detailsData.address.zipCode = config.retailer.settings.staticZipCode;
                        }
                    }

                    // if user has not address(text1) in delivery address just replace with user address
                    if (checkoutCtrl.detailsData && checkoutCtrl.detailsData.address && user.data && user.data.address) {
                        var address = checkoutCtrl.detailsData.address;
                        var userAddress = user.data.address;
                        if (address.city && !address.text1 && userAddress.city && userAddress.text1) {
                            angular.extend(checkoutCtrl.detailsData.address, userAddress)
                        }

                        if(!checkoutCtrl.detailsData.address.externalPlaceId){
                            angular.extend(checkoutCtrl.detailsData.address, {
                                externalPlaceId: userAddress.externalPlaceId
                            });
                        }
                       
                        detailsCtrl.setDeliveryTimes();
                    }

                    var cityPromise = $q.resolve();
                    if (detailsCtrl.deliveryAreaMethod === SP_SERVICES.DELIVERY_AREA_METHODS.ZIP_CODE || detailsCtrl.deliveryAreaMethod === SP_SERVICES.DELIVERY_AREA_METHODS.CITY) {
                        cityPromise = getCityAutoCompleteOptions().then(function (citiesList) {
                            if (!citiesList) {
                                return;
                            }

                            var foundCity = _findCityAndSetIsStreetRequired(citiesList);
                            if (!foundCity) {
                                delete checkoutCtrl.detailsData.address.city;
                            }
                        });
                    }

                    if (!checkoutCtrl.detailsData.delivery || !checkoutCtrl.detailsData.delivery.time) {
                        cityPromise.then(function () {
                            // run it from the detailsCtrl to run template overrides
                            detailsCtrl.setDeliveryTimes();
                        });
                    }

                    var cartLines = cart.getLines();
                    var cartLineProducts = [];

                    if (cartLines && Array.isArray(cartLines) && cartLines.length) {
                        angular.forEach(cartLines, function (cartLine) {
                            if (cartLine && cartLine.product && cartLine.product.id) {
                                cartLine.product.quantity = cartLine.quantity;
                                cartLineProducts.push(cartLine.product);
                            }
                        });
                    }

                    DataLayer.push(DataLayer.EVENTS.CHECKOUT, {products: cartLineProducts, data: {step: 2, option: 'user address and time slot'}});
                    checkoutCtrl.hasAddressDetails = util.checkAddressFields(checkoutCtrl.detailsData.address);
                    filterCountryNames();

                    _setOrInitValueForAddrField('isShowEditAddress', checkoutCtrl.detailsData.address.isShowEditAddress, false);
                    _setOrInitValueForAddrField('hasHouseNumberAndRoute', checkoutCtrl.detailsData.address.hasHouseNumberAndRoute, !checkoutCtrl.isDropPinAddressNotDetected);
                    _setOrInitValueForAddrField('isDisabledAddressField', checkoutCtrl.detailsData.address.isDisabledAddressField, false);

                    // Save current address for handling with coordinates and externalPlaceId
                    angular.extend(detailsCtrl.backupAddress, checkoutCtrl.detailsData.address);

                    // ECOM-6888: Cache previous address
                    var cloneAddress = angular.copy(user.data.address, {});
                    checkoutCtrl.previousFullDeliveryAddress = angular.copy({
                        address: cloneAddress,
                        externalPlaceId: cloneAddress.externalPlaceId
                    }, {});

                    // re-validate zipcode
                    detailsCtrl.onZipCodeBlur();

                    checkoutCtrl.checkoutOrderComment = util.getCheckoutOrderCommentConfig();
                });

                if(
                    // is in pilot updates
                    AddressFormService.isUseNewAddressesFeature && 
                    // is GOOGLE_MAPS / POLYGON
                    checkoutCtrl.isUseGMapDeliveryMethod
                ){
                    // GOOGLE_MAPS / POLYGON with Zip-code provider will use old form => don't need to load form settings
                    if (detailsCtrl.isGMapWithZipCodeProvider) {
                        detailsCtrl.streetIsRequire = config.retailer.settings.addressPrecision !== DELIVERY_AREA_METHODS_PRECISION.CITY_STREET_NOT_REQUIRED;
                        return;
                    }

                    detailsCtrl.streetIsRequire = true;
                    delete config.retailer.settings.enableDefaultCountry;
                
                    checkoutCtrl.isGoogleMapDropPinAllow = AddressFormService.isGoogleMapDropPinAllow;
                    checkoutCtrl.enableAddressFiltering = AddressFormService.enableAddressFiltering;
                    checkoutCtrl.isAddressFilteringCityMode = AddressFormService.isAddressFilteringCityMode;
                    checkoutCtrl.isAddressFilteringZipCodeMode = AddressFormService.isAddressFilteringZipCodeMode;
                }

                _init();

                function _init() {
                    $rootScope.spMixPanel.trackPreviousProperties({startAddressTime: new Date().getTime()});
                    if (config.retailer.settings.enableDefaultCountry) {
                        _addressComponents.push('country');
                    }
                }

                function _initSubstitutePreferences() {
                    var languagePreferences = _getSubstitutePreferencesConfig();
                    var substitutePreferences = (languagePreferences && languagePreferences.options) || [];

                    var defaultSubstitutePreference = config.retailer.settings.substitutePreferencesReturningCustomer;
                    var isDefaultMode = parseInt(defaultSubstitutePreference) === $rootScope.SUBSTITUTE_PREFERENCES_RETURNING_CUSTOMER.DEFAULT;

                    function buildSubstitutePreferencesResult(substitutePreference) {
                        var isExist = substitutePreference && substitutePreferences.some(function(item) {
                            return item.value === substitutePreference;
                        });
                        return {
                            substitutePreferencesTitle: languagePreferences.title,
                            substitutePreferences: substitutePreferences,
                            defaultSubstitutePreference: isExist ? substitutePreference : (substitutePreferences[0] && substitutePreferences[0].value)
                        };
                    }

                    if (isDefaultMode) {
                        return $q.resolve(buildSubstitutePreferencesResult());
                    }

                    // Get from last order
                    return _getLastOrder()
                        .then(function (lastOrder) {
                            var substitutePreference = (lastOrder && lastOrder.substitutePreferences) || null;
                            return buildSubstitutePreferencesResult(substitutePreference);
                        })
                        .catch(function () {
                            // If getting last order fails, use default
                            return buildSubstitutePreferencesResult();
                        });
                }

                function _getLastOrder() {
                    
                    return Orders.getLastOrder()
                        .then(function (order) {
                            if ($scope.$$destroyed || !order) {
                                return;
                            }

                            return order;
                        })
                }

                function _getSubstitutePreferencesConfig() {
                    var substitutePreferencesConfig = config.branch.settings && config.branch.settings.substitutePreferences || config.retailer.settings.substitutePreferences;
                    var languageId = $rootScope.config.language.id || LANGUAGES['en'];

                    return substitutePreferencesConfig && substitutePreferencesConfig[languageId];
                }

                function getSubstitutePreferenceLabel(value) {
                    var substitutePreference = detailsCtrl.substitutePreferences.find(function(item) {
                        return item.value === parseInt(value);
                    })
                    return substitutePreference ? substitutePreference.text : translateFilter('substitute_preference_' + value + '_label');
                }

                function _isAddressEnoughRequiredFields(){
                    return AddressFormService.isAddressEnoughFieldsToGetTimes(checkoutCtrl.detailsData.address);
                }

                function cancelPinnedAddress() {
                    checkoutCtrl.isDropPinAddress = false;
                    checkoutCtrl.isDropPinAddressNotDetected = false;
                    AddressFormService.cancelPinnedAddress(checkoutCtrl.detailsData.address);
                    _setOrInitValueForAddrField('hasHouseNumberAndRoute', true);
                    
                    detailsCtrl.setDeliveryTimes();
                }

                /**
                 * Primary title
                 * @public
                 *
                 * @returns {String}
                 */
                function primaryTitle() {
                    if (detailsCtrl.deliveryMethodOptions.length === 1) {
                        return detailsCtrl.deliveryMethodOptions[0].value.id === SP_SERVICES.DELIVERY_TYPES.DELIVERY ? 'Delivery Details' : 'Choose Your Pickup Time';
                    }

                    return 'How do you want to get your order?';
                }

                /**
                 * Validate address
                 * @public
                 *
                 * @returns {Boolean}
                 */
                function validateAddress() {
                    if (checkoutCtrl.detailsData.deliveryMethod.id !== SP_SERVICES.DELIVERY_TYPES.DELIVERY || checkoutCtrl.timesOption.picker.primaryItem) {
                        return true;
                    }

                    var pickerItems = checkoutCtrl.timesOption.picker.items;
                    for (var i = 0; i < pickerItems.length; i++) {
                        if (pickerItems[i].dropDown.items.length) {
                            return true;
                        }
                    }

                    var formElement = _getFormElement();

                    angular.forEach(['city', 'street', 'houseNum', 'entry', 'text1'], function (name) {
                        if (checkoutCtrl.detailsForm[name] && checkoutCtrl.detailsForm[name].$viewValue && checkoutCtrl.detailsForm[name].$invalid) {
                            angular.element(formElement.querySelector('[name=' + name + ']')).triggerHandler('blur');
                            // Emit address form error for required field validation
                            if (checkoutCtrl.detailsForm[name].$error && checkoutCtrl.detailsForm[name].$error.required) {
                                $rootScope.$emit($rootScope.SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_FORM_ERROR_DISPLAYED, {
                                    fieldWithError: name === 'text1' ? 'address' : name,
                                    errorType: 'Required Field'
                                });
                            }
                        }
                    });

                    return false;
                }

                function _setReceiptOption() {
                    var receiptDigitalConfig = {
                        isEnabled: false,
                        text: {}
                    };
                    if(config.retailer.settings.receiptDigital && typeof config.retailer.settings.receiptDigital === 'string') {
                        receiptDigitalConfig = util.tryParseJson(config.retailer.settings.receiptDigital) || receiptDigitalConfig;
                    }
                    if(receiptDigitalConfig.isEnabled) {
                        checkoutCtrl.detailsData.receiptOption = $rootScope.RECEIPT_TYPE_ID.DIGITAL;
                    }else if(Number(config.retailer.settings.receiptAfterFirstOrder) === $rootScope.DEFAULT_AFTER_FIRST_ORDER.DEFAULT) {
                        checkoutCtrl.detailsData.receiptOption = config.retailer.settings.receiptDefault;
                    } else {
                        checkoutCtrl.detailsData.receiptOption = user.data.receiptTypeId || config.retailer.settings.receiptDefault;
                    }
                }

                function _compileCustomValidatedPhone() {
                    if (checkoutCtrl.detailsData.mobilePhone && checkoutCtrl.detailsData.mobilePhone.customValidated) {
                        if (checkoutCtrl.detailsData.mobilePhone.phoneNumber && checkoutCtrl.detailsData.mobilePhone.phoneNumber !== '') {
                            checkoutCtrl.compiledPhoneNumber = [
                                checkoutCtrl.detailsData.mobilePhone.countryCode ? checkoutCtrl.detailsData.mobilePhone.countryCode.toString() : '',
                                checkoutCtrl.detailsData.mobilePhone.phoneNumber ? checkoutCtrl.detailsData.mobilePhone.phoneNumber.toString() : ''
                            ].join('')
                        }
                        else{
                            checkoutCtrl.compiledPhoneNumber = '';
                        }
                    }
                    else{
                        checkoutCtrl.compiledPhoneNumber = checkoutCtrl.detailsData.mobilePhone.phoneNumber;
                    }
                }

                function validatePhone() {

                    checkoutCtrl.phoneValidationSubmitted = true;
                    if(checkoutCtrl.detailsData.mobilePhone.customValidated){
                        checkoutCtrl.detailsData.mobilePhone.phoneNumber = [
                            checkoutCtrl.detailsData.mobilePhone.areaCode ? checkoutCtrl.detailsData.mobilePhone.areaCode.toString() : '',
                            checkoutCtrl.detailsData.mobilePhone.customPhoneNumber ? checkoutCtrl.detailsData.mobilePhone.customPhoneNumber.toString() : ''
                        ].join('')
                    }
                    return api.request({
                        method: 'POST',
                        url: '/v1/retailers/:rid/phone-number/is-valid',
                        data: {
                            phoneId: checkoutCtrl.detailsData.mobilePhone.id,
                            countryCode: checkoutCtrl.detailsData.mobilePhone.countryCode,
                            phoneNumber: checkoutCtrl.detailsData.mobilePhone.phoneNumber,
                            areaCode: checkoutCtrl.detailsData.mobilePhone.areaCode,
                            customPhoneNumber: checkoutCtrl.detailsData.mobilePhone.customPhoneNumber
                        }
                    });
                }

                function validateCountryCode(countryCode) {
                    if (checkoutCtrl.detailsData.mobilePhone.phoneNumber && checkoutCtrl.phoneValidationSubmitted) {
                        return config.retailer.customPhoneValidation.countryCodes.some(function (code) {
                            return code == countryCode;
                        });
                    }
                    return true;

                }

                function validateAreaCode(areaCode) {
                    if (checkoutCtrl.detailsData.mobilePhone.phoneNumber && checkoutCtrl.phoneValidationSubmitted) {
                        return config.retailer.customPhoneValidation.areaCodes.some(function (code) {
                            return code == areaCode;
                        });
                    }
                    return true;
                }

                function phoneEditMode(event, isEditing) {
                    if (detailsCtrl.customPhoneValidation) {
                        event.preventDefault();
                        if (detailsCtrl.editPhoneMode && isEditing) {
                            return;
                        }
                        if (checkoutCtrl.detailsData.mobilePhone.phoneNumber === undefined) {
                            checkoutCtrl.detailsData.mobilePhone.customValidated = true;
                        }
                        if (isEditing) {
                            detailsCtrl.editPhoneMode = true;
                            checkoutCtrl.detailsData.mobilePhone.phoneNumber = '';
                        } else {
                            detailsCtrl.editPhoneMode = false;
                            var inputField = document.getElementById('mobile_input');
                            if (inputField) {
                                inputField.blur()
                                checkoutCtrl.detailsForm.$setPristine();
                                checkoutCtrl.detailsForm.$setUntouched();
                            }
                            checkoutCtrl.detailsData.mobilePhone.phoneNumber = detailsCtrl.phoneNumber;
                        }
                    }
                }

                function onDeliveryMethodChanged() {
                    if(checkoutCtrl.area){
                        $rootScope.spMixPanel.trackPreviousProperties({
                            source: $rootScope.SP_SERVICES.SOURCES.CHANGE_DELIVERY_METHOD_POP_UP.CHECKOUT_ADDRESS, 
                            selectedStoreId: checkoutCtrl.area.id, 
                            deliveryTypeId: checkoutCtrl.area.deliveryTypeId
                        });
                    }
                    var newArea = !!config.branch && (config.branch.areas || []).find(function (area) {
                        return area.deliveryTypeId === checkoutCtrl.detailsData.deliveryMethod.id;
                    });
                    
                    $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_DELIVERY_METHOD_CHANGED, {
                        deliveryTypeId: newArea.deliveryTypeId,
                        selectedStoreId: newArea.id,
                    });
                    if (newArea) {
                        config.changeBranch(config.branch.id, newArea.id, {});
                    }
                    detailsCtrl.setDeliveryTimes();
                }

                function changeToDeliveryMethod() {
                    var deliveryMethodId = checkoutCtrl.detailsData.deliveryMethod.id;

                    if(deliveryMethodId === SP_SERVICES.DELIVERY_TYPES.PICKUP) {
                        deliveryMethodId = SP_SERVICES.DELIVERY_TYPES.DELIVERY;
                    } else {
                        deliveryMethodId = SP_SERVICES.DELIVERY_TYPES.PICKUP;
                    }

                    for (var i = 0; i < detailsCtrl.deliveryMethodOptions.length; i++) {
                        if (detailsCtrl.deliveryMethodOptions[i].value.id === deliveryMethodId) {
                            checkoutCtrl.detailsData = checkoutCtrl.detailsData || {};
                            checkoutCtrl.hasAddressDetails = util.checkAddressFields(checkoutCtrl.detailsData.address);
                            checkoutCtrl.detailsData.deliveryMethod = detailsCtrl.deliveryMethodOptions[i].value;
                            break;
                        }
                    }

                    detailsCtrl.onDeliveryMethodChanged();
                }

                function _filterAreasNotExpress(areas) {
                    if (!Array.isArray(areas)) {
                        throw new Error('Input must be an array');
                    }
                    return areas.filter(function(area) {
                        return area.deliveryTypeId !== SP_SERVICES.DELIVERY_TYPES.EXPRESS_DELIVERY;
                    });
                }

                var _oldDeliveryMethod,
                    _oldLanguageId,
                    _oldexternalPlaceId,
                    _oldAddress;

                /**
                 * Set delivery times
                 * @public
                 *
                 * @param {Object} [options={}]
                 *
                 * @returns {Promise}
                 */
                var _deliveryTimesPromise;
                var _deliveryTimesAbort = new AbortController();
                function setDeliveryTimes(options) {
                    options = options || {};

                    _cancelInactivityTimeout();

                    if (detailsCtrl.checkingAddressInProgress) {
                        return $q.reject();
                    }
                    
                    var params = {},
                        address = _getAddressText(),
                        externalPlaceId = (options && options.externalPlaceId) || checkoutCtrl.detailsData.address.externalPlaceId,
                        languageId = $rootScope.config.language.id,
                        deliveryMethod = checkoutCtrl.detailsData.deliveryMethod;
                        
                    if(deliveryMethod.id === SP_SERVICES.DELIVERY_TYPES.DELIVERY){
                        if (_oldDeliveryMethod === deliveryMethod && _oldAddress === address && _oldLanguageId === languageId && _oldexternalPlaceId === externalPlaceId
                            && !Object.keys(options).length
                        ) {
                            $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_ERROR);
                            return $q.reject();
                        }
                    }

                    checkIsOnePickupArea(deliveryMethod && deliveryMethod.id);
                    if (!options.scroll && (deliveryMethod !== _oldDeliveryMethod || (deliveryMethod.id === SP_SERVICES.DELIVERY_TYPES.DELIVERY && _oldAddress !== address))) {
                        _deleteDeliveryAreaFields();
                    }
                    var _currentOldAddress = _oldAddress
                    _oldAddress = address;

                    if (deliveryMethod.id === SP_SERVICES.DELIVERY_TYPES.DELIVERY) {
                        if(AddressFormService.isUseNewAddressesFeature){
                            switch (detailsCtrl.deliveryAreaMethod) {
                                case SP_SERVICES.DELIVERY_AREA_METHODS.ZIP_CODE:
                                case SP_SERVICES.DELIVERY_AREA_METHODS.CITY:{
                                    if (!address || !checkoutCtrl.detailsData.address.city) {
                                        $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_ERROR);
                                        return $q.reject('No Address');
                                    }

                                    if (detailsCtrl.streetIsRequire && !checkoutCtrl.detailsData.address.street || !checkoutCtrl.detailsData.address.houseNumber) {
                                        $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_ERROR);
                                        return $q.reject();
                                    }

                                    break;
                                }
                                case SP_SERVICES.DELIVERY_AREA_METHODS.POLYGON:
                                case SP_SERVICES.DELIVERY_AREA_METHODS.GOOGLE_MAPS:{
                                    // special flow for Zip code Provider - 'Get Address'
                                    if (checkoutCtrl.isGMapWithZipCodeProvider) {
                                        if (!address || !checkoutCtrl.detailsData.address.city) {
                                            $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_ERROR);
                                            return $q.reject('No Address');
                                        }
            
                                        if (detailsCtrl.isAddressVerificationEnabled) {
                                            var validationResult = _verifyCityAndAddress();
                                            var isValidAll = validationResult.city && validationResult.text1;
                                            if (!isValidAll) {
                                                $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_ERROR);
                                                return $q.reject('Invalid infor: city or address');
                                            }
                                        }

                                        if (detailsCtrl.streetIsRequire && !checkoutCtrl.detailsData.address.text1) {
                                            $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_ERROR);
                                            return $q.reject();
                                        }
                                    } else {
                                        // normal flow
                                        var isValid = _isAddressEnoughRequiredFields()
                                        if (!isValid) {
                                            $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_ERROR);
                                            return $q.reject('Invalid Address');
                                        }
                                        break;
                                    }
                                }
                            }
                        }else{
                            if (!address || !checkoutCtrl.detailsData.address.city) {
                                $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_ERROR);
                                return $q.reject('No Address');
                            }

                            if (detailsCtrl.isAddressVerificationEnabled) {
                                var validationResult = _verifyCityAndAddress();
                                var isValidAll = validationResult.city && validationResult.text1;
                                if (!isValidAll) {
                                    $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_ERROR);
                                    return $q.reject('Invalid infor: city or address');
                                }
                            }

                            if (detailsCtrl.streetIsRequire) {
                                switch (detailsCtrl.deliveryAreaMethod) {
                                    case SP_SERVICES.DELIVERY_AREA_METHODS.ZIP_CODE:
                                    case SP_SERVICES.DELIVERY_AREA_METHODS.CITY:
                                        if (!checkoutCtrl.detailsData.address.street || !checkoutCtrl.detailsData.address.houseNumber) {
                                            $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_ERROR);
                                            return $q.reject();
                                        }
                                        break;

                                    case SP_SERVICES.DELIVERY_AREA_METHODS.POLYGON:
                                    case SP_SERVICES.DELIVERY_AREA_METHODS.GOOGLE_MAPS:
                                        if (!checkoutCtrl.detailsData.address.text1) {
                                            $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_ERROR);
                                            return $q.reject();
                                        }
                                        break;
                                }
                            }
                        }
                    }

                    if (options.scroll) {
                        if (!checkoutCtrl.area) {
                            $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_ERROR);
                            return $q.reject();
                        }

                        if (checkoutCtrl.timesOptions && checkoutCtrl.timesOptions.length && checkoutCtrl.timesOptions[0].picker &&
                            checkoutCtrl.timesOptions[0].picker.items && checkoutCtrl.timesOptions[0].picker.items.length) {
                            params.startDate = new Date(new Date(checkoutCtrl.timesOptions[0].picker.items[checkoutCtrl.timesOptions[0].picker.items.length - 1].value.date).getTime() + DAY_IN_MS);

                            var today = spDeliveryTimesService.now();
                            today.setUTCHours(0, 0, 0, 0);

                            if (params.startDate >= (today.getTime() + (DAY_IN_MS * config.retailer.deliveryCustomerDisplayDays))) {
                                $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_ERROR);
                                return $q.reject();
                            }
                        }

                        if (!params.startDate &&
                            ((deliveryMethod.id === SP_SERVICES.DELIVERY_TYPES.DELIVERY && _oldDeliveryMethod === deliveryMethod && _currentOldAddress === address) ||
                                (deliveryMethod.id === SP_SERVICES.DELIVERY_TYPES.PICKUP && _oldDeliveryMethod === deliveryMethod))
                        ) {
                            $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_ERROR);
                            return $q.reject();
                        }
                    } else {
                        _resetTimesOptions();
                    }

                    _oldDeliveryMethod = deliveryMethod;
                    _oldexternalPlaceId = externalPlaceId;
                    _oldLanguageId = languageId;

                    var _isDropPinAddress = checkoutCtrl.detailsData.address.lat && checkoutCtrl.detailsData.address.lng && !checkoutCtrl.detailsData.address.externalPlaceId;
                    
                    angular.extend(params, {
                        address: {
                            text1: checkoutCtrl.detailsData.address.text1,
                            street: checkoutCtrl.detailsData.address.street,
                            houseNumber: checkoutCtrl.detailsData.address.houseNumber,
                            entry: _getEntryValue(checkoutCtrl.detailsData.address.entry),
                            city: checkoutCtrl.detailsData.address.city,
                            state: checkoutCtrl.detailsData.address.state,
                            zipCode: checkoutCtrl.detailsData.address.zipCode,

                            isDropPinAddress: _isDropPinAddress,
                            
                            // this field is used to support mobile app with old versions which don't have the new address version
                            // use in selfpointrest only
                            isNewAddressVersionV3: true,
                        },
                        cartId: cart.serverCartId,
                        languageId: languageId,
                        externalPlaceId: externalPlaceId,
                        isDeliveryWithinDaysByTag: config.retailer.isDeliveryWithinDaysByTag
                    });

                    if (checkoutCtrl.detailsData.deliveryMethod.id === SP_SERVICES.DELIVERY_TYPES.DELIVERY) {
                        var address = checkoutCtrl.detailsData.address || {};
                        if(_isDropPinAddress) {
                            // Add lat lng to params
                            params.lat = address.lat;
                            params.lng = address.lng;
                            params.externalPlaceId = null;
                        }

                        if(AddressFormService.isAddressFormSeparateStreetHouse) {
                            params.externalPlaceId = null;
                        }
                    }

                    if(_deliveryTimesPromise){
                        _deliveryTimesAbort.abort();
                        _deliveryTimesPromise = null;
                    }

                    _setFormError('');
                    $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_SUCCESSFULLY_SUBMITTED, {
                        endAddressTime: new Date().getTime(),
                        address: checkoutCtrl.detailsData.address,
                        allRequiredFieldsFilled: _isAddressEnoughRequiredFields(),
                        usedDropPin: checkoutCtrl.isDropPinAddress || false,
                        deliveryAreaMethod: detailsCtrl.deliveryAreaMethod,
                        addressCompletedMethod: detailsCtrl.addressCompletedMethod
                    });
                    delete checkoutCtrl.otherBranchResponse;
                    detailsCtrl.checkingAddressInProgress = true;
                    _deliveryTimesPromise = new Promise(function (resolve, reject) {
                        _deliveryTimesAbort.signal.addEventListener('abort', function () {
                            reject({ status: 'aborted'});
                        }, { once: true });
                        
                        return spDeliveryTimesService.getTimes(deliveryMethod.id, params).then(resolve).catch(reject);
                    }).then(function (resp) {
                        if (!resp || !resp.area) {
                            resp = {};
                            resp.area = {};
                            resp.times = {};
                            resp.area.areas = [];
                        }
                        var hasExpressDelivery = resp.area.areas && resp.area.areas.some(function(area) { 
                            return area.deliveryTypeId === SP_SERVICES.DELIVERY_TYPES.EXPRESS_DELIVERY; 
                        });
                        if (config.mobileExpressDeliverySettings && config.mobileExpressDeliverySettings.isActive && hasExpressDelivery) {
                            var areasNotExpress = _filterAreasNotExpress(resp.area.areas);
                            if (areasNotExpress.length === 0 ) {
                                return;
                            }
                            if(areasNotExpress.length > 0) {
                                resp.area = areasNotExpress[0];
                                resp.area.areas = areasNotExpress;
                                resp.times = resp.area.timesObject.times;
                            }
                        }
                        if (checkoutCtrl.detailsData.deliveryMethod !== deliveryMethod) {
                            return;
                        } else if (angular.isArray(resp.area.areas) && resp.area.areas.length > 1) {
                        if (options.scroll) {
                                angular.forEach(resp.area.areas, function (area) {
                                    _addScrollLocalDeliveryTimes(area, checkoutCtrl.areasById[area.id]);
                                });
                            } else {
                                checkoutCtrl.areasByName = {};
                                checkoutCtrl.areasById = {};
                                checkoutCtrl.areasOptions = [];
                                angular.forEach(resp.area.areas, function (area) {
                                    checkoutCtrl.areasByName[area.name] = checkoutCtrl.areasByName[area.name] || [];
                                    checkoutCtrl.areasByName[area.name].push(area);
                                    checkoutCtrl.areasById[area.id] = area;
                                    checkoutCtrl.areasOptions.push({name: area.name, id: area.id});
                                });

                                _setAreaByConfig();
                                return;
                            }
                        } else if (options.scroll) {
                            _addScrollLocalDeliveryTimes(resp.area, checkoutCtrl.area);
                        }

                        if (options.scroll) {
                            return _setTimesOptions(checkoutCtrl.area, {
                                localDelivery: checkoutCtrl.area.timesObject.times.localDelivery || {}
                            });
                        }

                        _setArea(resp.area);
                        return _setTimesOptions(resp.area, resp.times, {reset: true});
                    }).catch(function (resp) {
                        if(resp.status === 'aborted') return;

                        _resetTimesOptions();
                        switch (resp.statusCode) {
                            case 300:
                                var isIgnored = [
                                    checkoutCtrl.detailsData.address.lat && checkoutCtrl.detailsData.address.lng,
                                    checkoutCtrl.detailsData.address.externalPlaceId,
                                ].some(function (value) {
                                    return value;
                                });
                                if (isIgnored) {
                                    /**
                                     * ECOM-6403: After checkout, we will save the address to database, maybe that address is wrong format but it has externalPlaceId and coordinates
                                     * So, we will ignore the Did You Mean func
                                     */
                                    return;
                                }
                                return checkoutCtrl.showDidYouMeanDialog(resp.response.addresses, options, checkoutCtrl.detailsData.address).then(function (result) {
                                    if (!result) {
                                        return _setFormError('We didn\'t recognize the address you entered');
                                    }
                                });

                            case 303: {
                                // TODO remove after pilot done
                                var _isHiddenBranchNameFlow = AddressFormService.isUseNewAddressesFeature ? !detailsCtrl.isGMapWithZipCodeProvider : !config.retailer.settings.autocompleteAddressField;
                                if(detailsCtrl.isHiddenBranchName && _isHiddenBranchNameFlow) {
                                    return _chooseArea(resp.response.areas[0], checkoutCtrl.detailsData.address)
                                }

                                return checkoutCtrl.otherBranchResponse = resp.response;
                            }

                            case 400:
                                return _setFormError('We didn\'t recognize the address you entered');

                            case 404:
                                return _setFormError('Sorry, currently we do not deliver to this area, for further inquiries call');
                        }

                        if (resp instanceof Error) {
                            console.error(resp);
                        }
                    }).finally(function () {
                        detailsCtrl.checkingAddressInProgress = false;
                    });

                    return _deliveryTimesPromise;
                }

                function _addScrollLocalDeliveryTimes(fromArea, toArea) {
                    toArea.timesObject.times.localDelivery = toArea.timesObject.times.localDelivery || {};
                    toArea.timesObject.times.localDelivery[DELIVERY_TIMES_TYPES.REGULAR] = toArea.timesObject.times.localDelivery[DELIVERY_TIMES_TYPES.REGULAR] || [];
                    fromArea.timesObject.times.localDelivery = fromArea.timesObject.times.localDelivery || {};
                    fromArea.timesObject.times.localDelivery[DELIVERY_TIMES_TYPES.REGULAR] = fromArea.timesObject.times.localDelivery[DELIVERY_TIMES_TYPES.REGULAR] || [];
                    Array.prototype.push.apply(toArea.timesObject.times.localDelivery[DELIVERY_TIMES_TYPES.REGULAR], fromArea.timesObject.times.localDelivery[DELIVERY_TIMES_TYPES.REGULAR]);
                }


                function setDeliveryTimesFromAutocomplete(event) {
                    var nameAreas;
                    if (checkoutCtrl.areaQuery) {
                        nameAreas = checkoutCtrl.areasByName && checkoutCtrl.areasByName[checkoutCtrl.areaQuery];
                    }

                    var area;
                    if (nameAreas && nameAreas.length) {
                        if (event && event.option && event.option.id) {
                            area = nameAreas.find(function (areaItem) {
                                return areaItem.id === event.option.id;
                            });
                        } else if (nameAreas.length === 1) {
                            area = nameAreas[0];
                        }
                    }

                    if (!area) {
                        delete checkoutCtrl.area;
                        checkoutCtrl.areaChosenOption = null;
                        _resetTimesOptions();
                        return;
                    } else {
                        $rootScope.$emit('picker.backToStart');
                        checkoutCtrl.areaChosenOption = checkoutCtrl.areasOptions.find(function (option) {
                            return option.id === area.id;
                        });
                        if (!angular.isUndefined(checkoutCtrl.area)) {
                            if (area.id !== checkoutCtrl.area.id) {
                                checkoutCtrl.detailsData.delivery = {}
                            }
                        }
                    }

                    _setArea(area);
                    return _setTimesOptions(area, area.timesObject.times, {
                        reset: true
                    });
                }

                function _setArea(area) {
                    checkoutCtrl.area = area;
                    checkoutCtrl.detailsData.paymentMethods = deliveryMethods.paymentMethods[area.deliveryTypeId];
                }

                function _cancelInactivityTimeout() {
                    if (_timesInactivityTimeout) {
                        $timeout.cancel(_timesInactivityTimeout);
                        _timesInactivityTimeout = null;
                    }
                }

                function setDeliveryTimesAfterInactivity() {
                    if (detailsCtrl.deliveryAreaMethod !== SP_SERVICES.DELIVERY_AREA_METHODS.POLYGON &&
                        detailsCtrl.deliveryAreaMethod !== SP_SERVICES.DELIVERY_AREA_METHODS.GOOGLE_MAPS) {
                        return;
                    }

                    _cancelInactivityTimeout();

                    _timesInactivityTimeout = $timeout(function () {
                        // run it from the detailsCtrl to run template overrides
                        detailsCtrl.setDeliveryTimes();
                    }, 18000);
                }

                function onTimesOptionChange() {
                    checkoutCtrl.detailsData.isShippingService = checkoutCtrl.timesOption &&
                        checkoutCtrl.timesOption.label === TIMES_OPTIONS.SHIPPING_SERVICE;
                }

                function onCityChange() {
                    if (detailsCtrl.isAddressVerificationEnabled) {
                        $scope.$emit('checkout.details.hideFormError', {
                            hiddenFields: ['city'],
                        });
                        return;
                    }

                    $timeout(function () {
                        $rootScope.$emit('checkout.city.change');
                    }, 100);
                }

                function onZipCodeChange() {
                    if (!checkoutCtrl.isAddressFilteringZipCodeMode) {
                        return
                    }
                    if (detailsCtrl.isAddressVerificationEnabled) {
                        $scope.$emit('checkout.details.hideFormError', {
                            hiddenFields: ['zipCode'],
                        });
                        return;
                    }
                }

                function onCityBlur(event) {
                    if(_isClickToSuggestion(event)) return;

                    var _isCityChanged = _isLocationChanged('city');
                    _handleOnLocationBlur('city');
                    if (detailsCtrl.deliveryAreaMethod === SP_SERVICES.DELIVERY_AREA_METHODS.ZIP_CODE || detailsCtrl.deliveryAreaMethod === SP_SERVICES.DELIVERY_AREA_METHODS.CITY) {
                        onCityChosen();
                    } else {
                        if (AddressFormService.isUseNewAddressesFeature) {
                            if (detailsCtrl.isAddressVerificationEnabled) {
                                var city = _extractAddressField('city');
                                var isExisted = _isExistedInSuggestions(_ADDRESS_TYPE_MAP.city, city, detailsCtrl.suggestedCities);
                                if (!isExisted) {
                                    $scope.$emit('checkout.details.setFormError', 'city');
                                } else {
                                    $scope.$emit('checkout.details.hideFormError', {
                                        hiddenFields: ['city'],
                                    });
                                }

                                if (checkoutCtrl.isAddressFilteringCityMode && _isCityChanged) {
                                    detailsCtrl.suggestedAddresses = [];
                                    checkoutCtrl.detailsData.address.text1 = '';
                                    checkoutCtrl.detailsData.address.street = '';
                                    checkoutCtrl.detailsData.address.houseNumber = '';
                                    checkoutCtrl.detailsData.address.zipCode = '';
                                }
                            }
                        } else {
                            // run it from the detailsCtrl to run template overrides
                            if (detailsCtrl.isAddressVerificationEnabled) {
                                var city = _extractAddressField('city');
                                var isExisted = _isExistedInSuggestions(_ADDRESS_TYPE_MAP.city, city, detailsCtrl.suggestedCities);
                                if (!isExisted) {
                                    $scope.$emit('checkout.details.setFormError', 'city');
                                } else {
                                    $scope.$emit('checkout.details.hideFormError', {
                                        hiddenFields: ['city'],
                                    });
                                }
                            }
                        }
                        detailsCtrl.setDeliveryTimes();
                    }
                }

                function onCityChosen($event) {
                    if (detailsCtrl.isAddressVerificationEnabled) {
                        var cityComponent = $event && $event.option && $event.option.component;

                        if ($event.option.placeId) {
                            cityComponent.placeId = $event.option.placeId;
                        }

                        if (cityComponent) {
                            angular.extend(checkoutCtrl.detailsData.address, cityComponent);
                            $scope.$emit('checkout.details.hideFormError', {
                                hiddenFields: ['city'],
                            });
                        }

                        onCityBlur();
                        return;
                    }
                    onCityChange();
                    if (_getCitiesPromise) {
                        _getCitiesPromise.then(function (cities) {
                            var selectedCity = _findCityAndSetIsStreetRequired(cities);
                            //if the city has no streets or a street has been selected before
                            if (selectedCity && (selectedCity.type === CITY_TYPES.ONE_ZIP_CODE || checkoutCtrl.detailsData.address.street)) {
                                // run it from the detailsCtrl to run template overrides
                                detailsCtrl.setDeliveryTimes();
                            }
                        });
                    }
                }

                function onStreetBlur() {
                    $timeout(function () {
                        // run it from the detailsCtrl to run template overrides
                        detailsCtrl.setDeliveryTimes();
                    }, 100);
                }

                function disabledDeliveryDayChosen() {
                    if (!detailsCtrl.checkingAddressInProgress) {
                        util.showCommonDialog({
                            title: '{{\'Delivery Details\' | translate}}',
                            content: '<div style="font-size: 0.9em;">{{\'Please wait\' | translate}}...<br/>' + '{{\'Checking your address\' | translate}}.</div>',
                            controller: ['$scope', function ($scope) {
                                $scope.checkAddressTimeOut = $timeout(function () {
                                    $scope.hide();
                                }, 3000);
                            }]
                        });
                    } else {
                        detailsCtrl.validateAddress();
                    }
                }

                function _findCityAndSetIsStreetRequired(cities) {
                    for (var i = 0; i < cities.length; i++) {
                        if (cities[i].name === checkoutCtrl.detailsData.address.city) {
                            detailsCtrl.streetIsRequire = cities[i].type === CITY_TYPES.MULTIPLE_ZIP_CODES;
                            detailsCtrl.streetRequireMatch = (detailsCtrl.deliveryAreaMethod === SP_SERVICES.DELIVERY_AREA_METHODS.ZIP_CODE && cities[i].type === CITY_TYPES.MULTIPLE_ZIP_CODES);
                            return cities[i];
                        }
                    }
                }

                /**
                 * get cities list
                 * @public
                 */
                function getCityAutoCompleteOptions() {
                    var city = _extractAddressField('city');
                    if (!city) {
                        return $q.resolve([]);
                    }

                    //generate another promise that will return the full cities array (no only names)
                    var citiesDefer = $q.defer();
                    _getCitiesPromise = citiesDefer.promise;
                    var getRequestFunc = detailsCtrl.isAddressVerificationEnabled ? _getCitiesFromGoogleMapApi : _getInternalCities;

                    return getRequestFunc(city).then(function (data) {
                        detailsCtrl.suggestedCities = data.cities;
                        citiesDefer.resolve(data.cities);
                        return data.cities;
                    }).catch(function (err) {
                        citiesDefer.reject(err);
                        return _getCitiesPromise;
                    });
                }

                /**
                 * validate zip code
                 * @public
                 */
                function onZipCodeBlur() {
                    if (!checkoutCtrl.isAddressFilteringZipCodeMode) {
                        detailsCtrl.setDeliveryTimes();
                        return;
                    }
                    
                    var _isZipCodeChanged = _isLocationChanged('zipCode');
                    _handleOnLocationBlur('zipCode');

                    if (detailsCtrl.isAddressVerificationEnabled && _isZipCodeChanged) {
                        detailsCtrl.suggestedAddresses = [];
                        checkoutCtrl.detailsData.address.text1 = '';
                        checkoutCtrl.detailsData.address.city = '';
                    }

                    detailsCtrl.setDeliveryTimes();

                    // run it from the detailsCtrl to run template overrides
                    if (detailsCtrl.isAddressVerificationEnabled) {
                        var zipCode = _extractAddressField('zipCode');
                        if (!zipCode) {
                            return $q.resolve([]);
                        }

                        //generate another promise that will return the full cities array (no only names)
                        var zipCodesDefer = $q.defer();
                        var getRequestFunc = _getZipCodeFromGoogleMapApi;
                        
                        return getRequestFunc(zipCode).then(function (data) {
                            detailsCtrl.suggestedZipCodes = data.zipCodes;
                            var isExisted = _isExistedInSuggestions(_ADDRESS_TYPE_MAP.zipCode, zipCode, detailsCtrl.suggestedZipCodes);
                            if (!isExisted) {
                                $scope.$emit('checkout.details.setFormError', 'zipCode');
                                checkoutCtrl.isZipCodeValid = false;
                            } else {
                                $scope.$emit('checkout.details.hideFormError', {
                                    hiddenFields: ['zipCode'],
                                }); 
                                checkoutCtrl.isZipCodeValid = true;
                            }

                            zipCodesDefer.resolve(data.zipCodes);
                            return data.zipCodes;
                        }).catch(function (err) {
                            zipCodesDefer.reject(err);
                        });
                    }
                }
                
                /**
                 * get streets list
                 *@public
                 */
                function getStreetAutoCompleteOptions() {
                    if (!checkoutCtrl.detailsData.address.street) {
                        return $q.resolve([]);
                    }

                    return $q.resolve(_getCitiesPromise).then(function (cities) {
                        if (!cities) {
                            return $q.reject('no cities');
                        }

                        var cityId;
                        angular.forEach(cities, function (city) {
                            if (city.name === checkoutCtrl.detailsData.address.city) {
                                cityId = city.id;
                            }
                        });

                        if (!cityId) {
                            return $q.reject('city not found');
                        }

                        return cityId;
                    }).then(function (cityId) {
                        return api.request({
                            method: 'GET',
                            url: '/v2/addresses/streets',
                            params: {
                                term: checkoutCtrl.detailsData.address.street,
                                cityId: cityId,
                                size: 16
                            }
                        });
                    }).then(function (data) {
                        var streetsName = [];

                        angular.forEach(data.streets, function (street) {
                            streetsName.push(street.name);
                        });

                        return streetsName;
                    });
                }

                function getEntriesAutoComplete() {
                    var result = [];
                    angular.forEach(HOUSE_ENTRIES, function (entry) {
                        result.push(translateFilter(entry));
                    });
                    return result;
                }

                /**
                 * Go to next tab
                 * @public
                 */
                function nextTab() {
                    // Verify address
                    if (detailsCtrl.isAddressVerificationEnabled) {

                        var validationResult = _verifyCityAndAddress();
                        for (var key in validationResult) {
                            if (!validationResult[key]) {
                                var _input = document.querySelector('input[ng-model="checkoutCtrl.detailsData.address.' + key + '"]');
                                if (_input) {
                                    // temporary comment to resolve ECOM-20554
                                    // var _inputElement = angular.element(_input),
                                    //     _inputNgModelController = _inputElement.data('$ngModelController');
                                    // _inputNgModelController.$setValidity('spAutoCompleteRequireMatch', false);
                                    _input.focus();
                                }

                                _showErrorTooltip(key);
                                $scope.$emit('checkout.details.setFormError', key);
                                return;
                            }
                        }
                    }
                    // Verify country
                    var isEnableCountry = config.retailer.settings.enableDefaultCountry;
                    var isDelivery = checkoutCtrl.detailsData.deliveryMethod.id !== SP_SERVICES.DELIVERY_TYPES.PICKUP;
                    if (isEnableCountry && isDelivery) {
                        var currentCountry = checkoutCtrl.detailsData.address.country;
                        if (!currentCountry || !currentCountry.length) {
                            checkoutCtrl.detailsData.address.country = '';
                            return _showErrorTooltip('country');
                        } else {
                            var existedCountry = util.getCountryAutocompleteOptions().find(function (country) {
                                return country.toLowerCase() === currentCountry.toLowerCase();
                            });
                            if (existedCountry) {
                                checkoutCtrl.detailsData.address.country = existedCountry;
                            } else {
                                checkoutCtrl.detailsData.address.country = '';
                                return _showErrorTooltip('country');
                            }
                        }
                    }
                    // Run validate form
                    return detailsCtrl._validateForm().then(function (result) {
                        if (!result) return false;
                        detailsCtrl.editPhoneMode = false;
                        _compileCustomValidatedPhone();
                        checkoutCtrl.detailsData.address.entry = _getEntryValue(checkoutCtrl.detailsData.address.entry);
                        var minimumPrice = (!!user.data.personalMinOrderLimit || user.data.personalMinOrderLimit === 0) ?
                            user.data.personalMinOrderLimit : (checkoutCtrl.area.deliveryMinimumCost || Number(config.retailer.settings.minimumOrderPrice));
                        return util.validateMinimumCost(minimumPrice, config.retailer.notIncludeSpecials, checkoutCtrl.area.deliveryMinimumCost && checkoutCtrl.area.name)
                            .then(function () {
                                // var checkInvalidSales = !!cart.timeTravel || !!cart.total.giftsForView || !!cart.total.clubsGiftsForView;
                                var checkInvalidSales = true;
                                return _removeOldAndAddDeliveryProductLine().then(function () {
                                    if (checkInvalidSales) {
                                        return _checkInvalidSales();
                                    }

                                    return true;
                                });                                
                            }).then(function (continueToNextTab) {
                                if (!continueToNextTab) {
                                    return false;
                                }
                                if (cart.outOfStockLines && cart.outOfStockLines.length) {
                                    return util.openOutOfStockDialog(cart.outOfStockLines).then(function (result) {
                                        return !result || !result.isConfirmed ? $q.reject('Out of stock not confirmed') : true;
                                    });
                                }
                                return true;
                            }).then(function (continueToNextTab) {
                                if (!continueToNextTab) {
                                    return;
                                }
                                //  update User area, for next time load base con last change
                                if( (checkoutCtrl.area && checkoutCtrl.area.id) && (user.data.areaId != checkoutCtrl.area.id) ) {
                                    localStorageService.setItem('areaId', checkoutCtrl.area.id);
                                    localStorageService.setItem('area', checkoutCtrl.area.name);
                                    user.setUserArea(checkoutCtrl.area, user.session && user.session.userId, false);

                                }
                                
                                $state.go('app.checkout.summary');

                            });
                    });
                }

                /**
                 * Get Entry Value
                 * @private
                 *
                 * @param {String} entry
                 *
                 * @returns {String|null}
                 */
                function _getEntryValue(entry) {
                    if (entry === translateFilter(HOUSE_ENTRIES[0])) {
                        return null;
                    }
                    return entry;
                }

                /**
                 * LEGACY CODE. MOVED TO Cart.checkIrrelevantSales(). TODO reuse from service
                 * @private
                 *
                 * @returns {Promise}
                 */
                function _checkInvalidSales() {
                    var skipDialogSpecial = false;
                    if (!cart.timeTravel && !cart.total.giftsForView && !cart.total.clubsGiftsForView) {
                        skipDialogSpecial = true;
                    }
                    // if the specials will be calculated by the checkout time at the pos, there is no reason to check invalid sales
                    if (config.retailer.settings.specialsCalculationTime === CHARGE_SPECIALS_CALCULATION_TIME.CHECKOUT_POS ||
                        config.retailer.settings.specialsCalculationTime === CHARGE_SPECIALS_CALCULATION_TIME.CHECKOUT_SP) {
                        skipDialogSpecial = true;
                    }

                    if (!checkoutCtrl.detailsData.delivery.times || !checkoutCtrl.detailsData.delivery.time) {
                        return $q.resolve(true);
                    }

                    var saleDate;
                    // TODO: when special will support schedule should check express times too
                    if (checkoutCtrl.detailsData.delivery.time.typeId === DELIVERY_TIMES_TYPES.DELIVERY_WITHIN_DAYS) {
                        saleDate = new Date();
                        saleDate.setTime(saleDate.getTime() +
                            checkoutCtrl.detailsData.delivery.time.daysRange * DAY_IN_MS -
                            saleDate.getTimezoneOffset() * MINUTE_IN_MS);
                    } else if (checkoutCtrl.detailsData.delivery.times.date) {
                        var date = new Date(checkoutCtrl.detailsData.delivery.times.date),
                            time = new Date(checkoutCtrl.detailsData.delivery.time.to);

                        saleDate = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), time.getUTCHours(), time.getUTCMinutes(), time.getUTCSeconds());
                        saleDate.setMinutes(saleDate.getMinutes() - saleDate.getTimezoneOffset());
                    }

                    var saveCartPromise = $q.resolve();

                    if (saleDate && !skipDialogSpecial) {
                        cart.setTimeTravel({
                            date: saleDate,
                            override: false
                        });
                        saveCartPromise = cart.save();
                    }


                    return saveCartPromise.then(function () {
                        var irrelevantSalesObj = getIrrelevantSales(),
                            irrelevantSales = irrelevantSalesObj.irrelevantSalesLines,
                            lineTypes = irrelevantSalesObj.lineTypes,
                            expiredInfo = filterIrrelevantSpecialsAndCoupons(irrelevantSales);

                        function getIrrelevantSales() {
                            var irrelevantSalesLines = [],
                                lineTypes = {},
                                deliveryDate = new Date(checkoutCtrl.detailsData.delivery.times.date);
                            angular.forEach(cart.lines || [], function(line) {
                                if (!skipDialogSpecial && util.isIrrelevantSale(line)) {
                                    irrelevantSalesLines.push(line);
                                    lineTypes[line.type] = true;
                                } else if(line && !util.isSellOnDate(line,deliveryDate)){
                                    irrelevantSalesLines.push(line);
                                    lineTypes[line.type] = true;
                                } else if (line && util.isCateringProduct(line) && !util.isEnoughTimeToPrepare(line, new Date(checkoutCtrl.detailsData.delivery.time.newTo.replace('Z', '')))) {
                                    irrelevantSalesLines.push(line)
                                    lineTypes[line.type] = true;
                                }
                            });
                            return { irrelevantSalesLines: irrelevantSalesLines, lineTypes: lineTypes };
                        }

                        function findSepcial(specials, specialId) {
                            var result = specials.find(function(special) {
                                return special.id === specialId;
                            });
                            return result;
                        }

                        function filterIrrelevantSpecialsAndCoupons(cartLines){
                            var irrelevantSpeicalIndex = {},
                                deliveryDate = new Date(checkoutCtrl.detailsData.delivery.times.date),

                                expiredInfo = {};
                                expiredInfo[INVALID_SALES_TYPES.SELL_DATES] = {
                                    items: [],
                                    mainTitle: '',
                                    subTitle: '',
                                    itemTemplateUrl: 'template/dialogs/sell-date/product.html',
                                    className: 'sell-date-dialog'
                                };
                                expiredInfo[INVALID_SALES_TYPES.SPECIAL] = {
                                    items: [],
                                    mainTitle: '',
                                    subTitle: '',
                                    itemTemplateUrl: 'template/views/cart-summary/partials/carousel-special-item/index.html'
                                };
                                expiredInfo[INVALID_SALES_TYPES.COUPON] = {
                                    items: [],
                                    mainTitle: '',
                                    subTitle: '',
                                    itemTemplateUrl: 'template/views/cart-summary/partials/carousel-coupon-item/index.html'
                                };
                                expiredInfo[INVALID_SALES_TYPES.CATERING_PRODUCT] = {
                                    items: [],
                                    mainTitle: '',
                                    subTitle: '',
                                    itemTemplateUrl: 'template/dialogs/catering-product/product.html',
                                    className: ''
                                };
                            var deliveryDateWithoutTimeInStringArray = (util.getDataByPath(checkoutCtrl, 'detailsData.delivery.times.date') || '').split('.');
                            var deliveryDateWithoutTime = new Date(deliveryDateWithoutTimeInStringArray && deliveryDateWithoutTimeInStringArray.length > 0 ? deliveryDateWithoutTimeInStringArray[0] : '');
                            angular.forEach(cartLines, function(line) {
                                if(line.product){
                                    if (line.product.branch && line.product.branch.specials) {
                                        var specials = line.product.branch.specials;
                                        angular.forEach(line.gifts, function (gift) {
                                            var endDate = new Date(gift.promotion.endDate);
                                            var giftId = gift.promotion.id;
                                            var isGiftInvalid = endDate < deliveryDateWithoutTime || gift.irrelevantSale;
                                            if(isGiftInvalid && !irrelevantSpeicalIndex[giftId]) {
                                                irrelevantSpeicalIndex[giftId]= true;
                                                if(specials) {
                                                    // This gift is a special, we can extract its information in the specials
                                                    var special = findSepcial(specials, giftId);
                                                    if(!special) {
                                                        // In case, a product is applied both special and coupon, because the coupon does not exist in special fields, so we treat it as a coupon
                                                        expiredInfo.coupon.items.push(gift);
                                                    } else {
                                                        special.frontendImageUrl = line.product && line.product.image && line.product.image.url;
                                                        expiredInfo.special.items.push(special);
                                                    }
                                                } else {
                                                    // Temporarily, treat this gift as a coupon
                                                    if(line.type === SP_SERVICES.CART_LINE_TYPES.COUPON) { //== only if Cart Line type is Coupon
                                                        expiredInfo.coupon.items.push(gift);
                                                    }
                                                }
                                            }
                                        });
                                    }
                                    if(!util.isSellOnDate(line,deliveryDate)){
                                        expiredInfo.sellDates.items.push(line);
                                        return;
                                    }

                                    if(util.isCateringProduct(line) && !util.isEnoughTimeToPrepare(line, deliveryDate)) {
                                        expiredInfo.cateringProduct.items.push(line);
                                        return;
                                    }
                                }
                            });
                            return expiredInfo;
                        }

                        var isNewPromotionDesignEnabled = $rootScope.config.retailer.settings.isNewPromotionDesignEnabled === 'true';
                        var isEmptyExpiredItem = !expiredInfo.coupon.items.length && !expiredInfo.special.items.length && !expiredInfo.sellDates.items.length && !expiredInfo.cateringProduct.items.length;
                        
                        if(isNewPromotionDesignEnabled && isEmptyExpiredItem || !irrelevantSales.length) {
                            return true;
                        }


                        /**
                         *  * Handle dialog click actions for different types of invalid sales
                         * @private
                         * @param {boolean} rs - Response from dialog
                         * @returns {boolean}
                         */
                        function _handleClickDialog(rs){
                            if (!rs) return false;

                            // values in this array must be the same as expiredInfo keys
                            var salesTypesToCheck = ['sellDates', 'cateringProduct'];
                            var invalidSalesItems = [];

                            salesTypesToCheck.forEach(function (type) {
                                if(expiredInfo[type] && expiredInfo[type].items && expiredInfo[type].items.length > 0) {
                                    invalidSalesItems = invalidSalesItems.concat(expiredInfo[type].items);
                                }
                            });

                            if (invalidSalesItems.length > 0) {
                                return handleRemoveItems(invalidSalesItems);
                            } else {
                                return true;
                            }
                        }
                        // old promotion desgin check on lines, new promotion check on specials
                        // In case, We do not have any expired specials and coupons
                        // In case, we have some expired coupons
                        if(expiredInfo.coupon.items.length) {
                            var couponIds = expiredInfo.coupon.items.map(function (c) {
                                return c.promotion.id;
                            });
                            return _getCoupons(couponIds).then(function (couponDetails) {
                                expiredInfo.coupon.items = couponDetails;
                                return _showIrrelevantSalesDialog(isNewPromotionDesignEnabled, lineTypes, expiredInfo, irrelevantSales, skipDialogSpecial).then(_handleClickDialog);
                            });
                        }
                        return _showIrrelevantSalesDialog(isNewPromotionDesignEnabled, lineTypes, expiredInfo, irrelevantSales, skipDialogSpecial).then(_handleClickDialog);
                    }).then(function (isContinueToNextTab) {
                        if(isContinueToNextTab) {
                            if(!skipDialogSpecial) {
                                cart.setTimeTravel({
                                    override: true
                                });
                                cart.save()
                            }
                            return isContinueToNextTab;
                        }
                    });
                }

                function handleRemoveItems(items) {
                    return cart.removeLines(items)
                        .then(function() {
                            return cart.save();
                        })
                        .catch(function() {
                            return false;
                        });
                }

                /**
                 * Get address text
                 * @private
                 *
                 * @returns {String}
                 */
                function _getAddressText() {
                    var address = checkoutCtrl.detailsData.address,
                        text;
                    if (detailsCtrl.deliveryAreaMethod === SP_SERVICES.DELIVERY_AREA_METHODS.ZIP_CODE || detailsCtrl.deliveryAreaMethod === SP_SERVICES.DELIVERY_AREA_METHODS.CITY) {
                        text = (address.street || '') + ' ' + (checkoutCtrl.detailsData.address.city || '') + ' ' + (checkoutCtrl.detailsData.address.houseNumber || '') + (checkoutCtrl.detailsData.address.entry || '');
                    } else {
                        text = (address.text1 || address.street + ' ' + address.houseNumber) + ' ' + (checkoutCtrl.detailsData.address.city || '');
                    }
                    return (text + (address.state ? ' ' + address.state : '') + (address.zipCode ? ' ' + address.zipCode : '')).trim();
                }

                /**
                 * Reset times options
                 * @private
                 */
                function _resetTimesOptions() {
                    checkoutCtrl.isDeliveryWithinDaysOnly = false;
                    if (checkoutCtrl.detailsData) {
                        checkoutCtrl.detailsData.delivery = {};
                    }

                    var timeOption = {
                        picker: {
                            key: 'times',
                            templateUrl: 'template/views/checkout/partials/delivery-day/index.html',
                            items: _getEmptyDeliveryDays().map(function (day) {
                                return {
                                    templateUrl: 'template/views/checkout/partials/delivery-time-dropdown-disabled/index.html',
                                    value: day,
                                    deliveryMethod: checkoutCtrl.detailsData.deliveryMethod,
                                    dropDown: {
                                        items: []
                                    }
                                };
                            })
                        }
                    };

                    //on checkoutCtrl to stay there if went to summary page and got back to details page
                    checkoutCtrl.timesOptions = [timeOption];
                    checkoutCtrl.timesOption = timeOption;

                    //== go back to the first week when resetting
                    $rootScope.$emit('picker.backToStart');

                    onTimesOptionChange();
                }

                function _getEmptyDeliveryDays() {
                    return spDeliveryTimesService.timesObject(null, null, config.retailer.deliveryCustomerDisplayDays)[DELIVERY_TIMES_TYPES.REGULAR];
                }

                /**
                 * Set the times options by the given times result
                 * @private
                 *
                 * @param {Object} area
                 * @param {Object} times
                 * @param {Array<Object>} times.localDelivery
                 * @param {Array<Object>} times.shipping
                 * @param {Object} [options]
                 * @param {boolean} [options.reset]
                 *
                 * @return {Promise<void>}
                 */
                function _setTimesOptions(area, times, options) {
                    return $q.resolve().then(function () {
                        if (!times.localDelivery) {
                            return;
                        }
                        return _getLocalDeliveryTimesOption(area, times.localDelivery, options);
                    }).then(function (localDeliveryTimesOption) {
                        if (options && options.reset) {
                            checkoutCtrl.timesOptions = [];
                            if (localDeliveryTimesOption) {
                                checkoutCtrl.timesOptions.push(localDeliveryTimesOption);
                            }
                            if (times.shipping) {
                                checkoutCtrl.timesOptions.push(_getShippingTimes(times.shipping));
                            }
                            checkoutCtrl.timesOption = checkoutCtrl.timesOptions[0];
                        } else {
                            var localDeliveryCurrentOption = _findLocalDeliveryTimesOption();
                            if (localDeliveryCurrentOption) {
                                checkoutCtrl.timesOptions.splice(checkoutCtrl.timesOptions.indexOf(localDeliveryCurrentOption), 1);
                            }
                            checkoutCtrl.timesOptions.unshift(localDeliveryTimesOption);
                            checkoutCtrl.timesOption = localDeliveryTimesOption;
                        }
                        onTimesOptionChange();
                    })
                }

                /**
                 * Get the local delivery times option by the given local delivery times
                 * @private
                 *
                 * @param {Object} area
                 * @param {Array<Object>} times
                 * @param {Object} [options]
                 * @param {boolean} [options.reset]
                 *
                 * @returns {Promise<{label: string, picker: Object}>}
                 */
                function _getLocalDeliveryTimesOption(area, times, options) {
                    return spDeliveryTimesService.isDeliveryWithinDaysOnly({
                        deliveryTimesObj: times,
                        isDeliveryWithinDaysByTag: config.retailer.isDeliveryWithinDaysByTag,
                        retailerId: config.retailer.id,
                        areaId: area.id
                    }).then(function (isDeliveryWithinDaysOnly) {
                        options = options || {};
                        var picker = {
                            key: 'times',
                            templateUrl: 'template/views/checkout/partials/delivery-day/index.html',
                            items: [],
                            deliveryMethod: checkoutCtrl.detailsData.deliveryMethod,
                            orderTimeByKey: config.retailer.twoHourLaw && checkoutCtrl.detailsData.deliveryMethod.id === SP_SERVICES.DELIVERY_TYPES.DELIVERY ? 'fromDisplay' : 'from'
                        };

                        checkoutCtrl.isDeliveryWithinDaysOnly = isDeliveryWithinDaysOnly;

                        var withinHoursDelivery = times[DELIVERY_TIMES_TYPES.DELIVERY_WITHIN_HOURS],
                            withinDaysDelivery = times[DELIVERY_TIMES_TYPES.DELIVERY_WITHIN_DAYS];
                        if (withinHoursDelivery && !checkoutCtrl.isDeliveryWithinDaysOnly) {
                            var expressLimits = spDeliveryTimesService.getExpressTimeProductTagLimits(config.retailer.isExpressDeliveryByTag, config.retailer.expressDeliveryProductsLimit);
                            picker.primaryItem = _getPickerPrimaryTimeItem(withinHoursDelivery, area, expressLimits);
                        } else if (withinDaysDelivery) {
                            picker.primaryItem = _getPickerPrimaryTimeItem(withinDaysDelivery, area, {
                                isEnabled: true,
                                isUnderQuantityLimit: true
                            });

                            if (checkoutCtrl.isDeliveryWithinDaysOnly) {
                                checkoutCtrl.detailsData.delivery.time = withinDaysDelivery;
                                checkoutCtrl.detailsData.delivery.times = {};
                            }
                        }
                        var unavailableSlotsCount = 0;
                        var availableSlotsCount = 0;
                        angular.forEach(times[DELIVERY_TIMES_TYPES.REGULAR] || (options.reset ? _getEmptyDeliveryDays() : []), function (dayTimes) {
                            var item = {
                                templateUrl: 'template/views/checkout/partials/delivery-time-dropdown' + (dayTimes.times.length ? '' : '-disabled') + '/index.html',
                                value: dayTimes,
                                dropDown: {
                                    key: 'time',
                                    default: 0,
                                    items: []
                                }
                            };

                            if (dayTimes.times.length) {
                                var firstFromTime;
                                item.dropDown.withSpecials = false;
                                angular.forEach(dayTimes.times, function (time, index) {
                                    item.dropDown.items.push(_getPickerTimeItem(time, dayTimes, area));

                                    if (!firstFromTime || firstFromTime > time.from) {
                                        firstFromTime = time.from;
                                        item.dropDown.default = index;
                                    }

                                    if (time.deliveryProduct && time.deliveryProduct.branch && time.deliveryProduct.branch.specials && time.deliveryProduct.branch.specials.length) {
                                        item.dropDown.withSpecials = true;
                                    }
                                    if(time.isActive){
                                        availableSlotsCount++;
                                    }
                                    else{
                                        unavailableSlotsCount++;
                                    }
                                });
                            } else {
                                item.disabled = true;
                                unavailableSlotsCount++;
                            }

                            picker.items.push(item);
                        });
                        var filteringMode = _FILTERING_MODES.NONE;
                        if(checkoutCtrl.isAddressFilteringCityMode){
                            filteringMode = _FILTERING_MODES.CITY;
                        }
                        else if(checkoutCtrl.isAddressFilteringZipCodeMode){
                            filteringMode = _FILTERING_MODES.ZIP_CODE;
                        }
                        else if(checkoutCtrl.isAddressFilteringStreetMode){
                            filteringMode = _FILTERING_MODES.STREET;
                        }
				
                        $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_DELIVERY_SLOT_STEP_VIEW, {
                            selectedStoreId: area.id,
                            earlyDeliveryOptionShown: $rootScope.config.retailer.isAsapActive,
                            deliveryTypeId: area.deliveryTypeId,
                            unavailableSlotsCount: unavailableSlotsCount,
                            availableSlotsCount: availableSlotsCount,
                            addressCompletedMethod: detailsCtrl.addressCompletedMethod,
                            filteringMode: filteringMode,
                        });
                        return {
                            label: TIMES_OPTIONS.LOCAL_DELIVERY,
                            picker: picker
                        };
                    });
                }

                function _findLocalDeliveryTimesOption() {
                    return checkoutCtrl.timesOptions.find(function (timesOption) {
                        return timesOption.label === TIMES_OPTIONS.LOCAL_DELIVERY;
                    });
                }

                function _getPickerTimeItem(time, times, area) {
                    if (checkoutCtrl.detailsData.delivery && checkoutCtrl.detailsData.delivery.time && checkoutCtrl.detailsData.delivery.time.id === time.id) {
                        checkoutCtrl.detailsData.delivery.time = time;
                        checkoutCtrl.detailsData.delivery.times = times;
                    }

                    var timeFormat = config.isUs ? 'hh:mm a' : 'HH:mm',
                        label;
                    if (config.retailer.twoHourLaw && checkoutCtrl.detailsData.deliveryMethod.id === SP_SERVICES.DELIVERY_TYPES.DELIVERY) {
                        label = dateFilter((time.fromDisplay || time.from), timeFormat, 'UTC');
                    } else {
                        if (detailsCtrl.checkoutPromotionSettings && detailsCtrl.checkoutPromotionSettings.isEnabled) {
                            var formattedFrom = dateFilter(time.from, 'hh:mm', 'UTC');
                            var formattedTo = dateFilter(time.to, 'hh:mm', 'UTC');
                            label = formattedFrom + ' - ' + formattedTo;
                        } else {
                            label = dateFilter(time.from, timeFormat, 'UTC') + '-' + dateFilter(time.to, timeFormat, 'UTC');
                        }
                    }

                    var salePrice = util.getSalePriceForTimeSlot(time);

                    return {
                        from: time.from,
                        fromDisplay: time.fromDisplay,
                        to: time.to,
                        label: label,
                        value: time,
                        salePrice: salePrice,
                        price: (time.deliveryFeeForEntireDay && time.deliveryFeeForEntireDay.retailerProductPrice) || time.deliveryTimePrice || area.deliveryAreaPrice || 0,
                        specials:
                            time.deliveryProduct && time.deliveryProduct.branch && time.deliveryProduct.branch.specials ?
                                time.deliveryProduct.branch.specials.filter(function (special) {
                                    return config.retailer.settings.showCouponsSpecials || !special.isCoupon;
                                }) : null
                    };
                }

                /**
                 *
                 * @private
                 *
                 * @param {Object} time
                 * @param {Object} area
                 * @param {Object} [cartOptions]
                 * @param {boolean} [cartOptions.isEnabled]
                 * @param {boolean} [cartOptions.isUnderQuantityLimit]
                 *
                 * @return {Object}
                 */
                function _getPickerPrimaryTimeItem(time, area, cartOptions) {
                    cartOptions = cartOptions || {};

                    if (checkoutCtrl.detailsData.delivery && checkoutCtrl.detailsData.delivery.time && checkoutCtrl.detailsData.delivery.time.id === time.id) {
                        checkoutCtrl.detailsData.delivery.time = time;
                        checkoutCtrl.detailsData.delivery.times = {};
                    }

                    return {
                        value: {},
                        price: (time.deliveryFeeForEntireDay && time.deliveryFeeForEntireDay.retailerProductPrice) || time.deliveryTimePrice || area.deliveryAreaPrice || 0,
                        templateUrl: 'template/views/checkout/partials/delivery-within/index.html',
                        isDisabled: !cartOptions.isEnabled || !cartOptions.isUnderQuantityLimit,
                        customData: {
                            deliveryTimeTypeId: time.typeId,
                            exceededCartLimit: !cartOptions.isUnderQuantityLimit,
                            cartDisabled: !cartOptions.isEnabled,
                            productsLimit: config.retailer.expressDeliveryProductsLimit,
                            deliveryTypeStr: checkoutCtrl.detailsData.deliveryMethod.id === SP_SERVICES.DELIVERY_TYPES.DELIVERY ? 'delivery' : 'pickup'
                        },
                        dropDown: {
                            key: 'time',
                            items: [time],
                            default: 0
                        },
                        specials: cartOptions.isEnabled && cartOptions.isUnderQuantityLimit &&
                        time.deliveryProduct && time.deliveryProduct.branch && time.deliveryProduct.branch.specials ?
                            time.deliveryProduct.branch.specials.filter(function (special) {
                                return config.retailer.settings.showCouponsSpecials || !special.isCoupon;
                            }) : null
                    };
                }

                /**
                 * Get shipping times
                 * @private
                 *
                 * @param {Array} times
                 *
                 * @returns {{label: {String}, picker: {Object}}}
                 */
                function _getShippingTimes(times) {
                    var picker = {
                        key: 'time',
                        templateUrl: 'template/views/checkout/partials/shipping-day/index.html',
                        items: []
                    };

                    angular.forEach(times, function (time) {
                        picker.items.push({
                            value: time,
                            price: time.price
                        });

                        if (checkoutCtrl.detailsData.delivery && checkoutCtrl.detailsData.delivery.time && checkoutCtrl.detailsData.delivery.time.serviceCode === time.serviceCode) {
                            checkoutCtrl.detailsData.delivery.time = time;
                        }
                    });

                    return {
                        label: TIMES_OPTIONS.SHIPPING_SERVICE,
                        picker: picker
                    };
                }

                /**
                 * Add the delivery product line based on if delivery time slot has it , else do default
                 * @private
                 */
                function _removeOldAndAddDeliveryProductLine() {
                    var promises = [];
                    // remove old delivery & service fee lines
                    angular.forEach(cart.lines, function (line) {
                        if (line.type === SP_SERVICES.CART_LINE_TYPES.DELIVERY || line.type === SP_SERVICES.CART_LINE_TYPES.SERVICE_FEE) {
                            line.removed = true;
                            checkoutCtrl.waitForSaveCart = true;
                            promises.push(cart.removeLine(line));
                        }
                    });

                    // handle service fee
                    if (config.retailer.serviceFeeProduct) {
                        checkoutCtrl.waitForSaveCart = true;
                        promises.push(cart.addLine({
                            quantity: 1,
                            type: SP_SERVICES.CART_LINE_TYPES.SERVICE_FEE,
                            product: {
                                id: config.retailer.serviceFeeProduct.id
                            }
                        }));
                    }

                    // handle delivery
                    var deliveryTimeProductId;
                    if (checkoutCtrl.detailsData.isShippingService) {
                        deliveryTimeProductId = checkoutCtrl.area.providerDeliveryProductId;
                    } else if (!checkoutCtrl.detailsData.delivery.time) {
                        deliveryTimeProductId = checkoutCtrl.area.deliveryProductId;
                    } else if (checkoutCtrl.detailsData.delivery.time.deliveryFeeForEntireDay) {
                        deliveryTimeProductId = checkoutCtrl.detailsData.delivery.time.deliveryFeeForEntireDay.retailerProductId;
                    } else {
                        deliveryTimeProductId = checkoutCtrl.detailsData.delivery.time.deliveryTimeProductId || checkoutCtrl.area.deliveryProductId;
                    }

                    if (deliveryTimeProductId) {
                        checkoutCtrl.waitForSaveCart = true;
                        promises.push(cart.addLine({
                            quantity: Math.round(checkoutCtrl.detailsData.delivery.time.price * 100),
                            type: SP_SERVICES.CART_LINE_TYPES.DELIVERY,
                            product: {
                                id: deliveryTimeProductId
                            }
                        }));
                    }

                    return Promise.all(promises);
                }

                /**
                 * Validate the details form
                 * @private
                 *
                 * @returns {Boolean}
                 */
                function _validateForm() {
                    return detailsCtrl.validatePhone().then(function (isPhoneValid) {
                        return checkoutCtrl.detailsForm.$invalid || !checkoutCtrl.detailsData.delivery || !checkoutCtrl.detailsData.delivery.time || !isPhoneValid;
                    });
                }

                /**
                 * Set form error message
                 * @private
                 *
                 * @param {String} [message]
                 */
                function _setFormError(message, isNotSave) {
                    // ECOM-2174: ES5 does not have default value for params, so I use negative isNotSave
                    if (message && !isNotSave) {
                        detailsCtrl.formErrorMessage = message;
                    }
                    util.setServerErrorToForm(checkoutCtrl.detailsForm, _getFormElement(), translateFilter(message));
                }

                function _getFormElement() {
                    return document.getElementsByName('checkoutCtrl.detailsForm')[0];
                }

                function changeStore($event) {
                    if(checkoutCtrl.area){
                        $rootScope.spMixPanel.trackPreviousProperties({
                        source: $rootScope.SP_SERVICES.SOURCES.CHANGE_DELIVERY_METHOD_POP_UP.CHECKOUT_ADDRESS, 
                            selectedStoreId: checkoutCtrl.area.id, 
                            deliveryTypeId: checkoutCtrl.area.deliveryTypeId
                        });
                    }
                    return SpDeliveryAreasService.getChooseAreaMode().then(function (mode) {
                        var isPickup = checkoutCtrl.detailsData.deliveryMethod.id === SP_SERVICES.DELIVERY_TYPES.PICKUP,
                            areaName = null, addressDetails = {};
                        if (!isPickup) {
                            if (checkoutCtrl.otherBranchResponse && mode === SP_SERVICES.CHOOSE_AREA_MODE.TYPE_AREA) {
                                areaName = ((checkoutCtrl.otherBranchResponse.names || [])[0] || {}).name ||
                                    checkoutCtrl.otherBranchResponse.name;
                            }
                            if (mode === SP_SERVICES.CHOOSE_AREA_MODE.TYPE_GOOGLE_ADDRESS) {
                                var _addressQuery = util.getAddressQueryForChooseArea(checkoutCtrl.detailsData.address);
                                areaName = _addressQuery.areaName;
                                addressDetails = _addressQuery.addressDetails;
                            }
                        }
                        return ChooseAreaDialog.show(false, null, areaName, $event, isPickup, addressDetails);
                    }).then(function () {
                        _setAreaByConfig();
                    });
                }

                function _chooseArea(area, address) {
                    var sessionUserId = user.session && user.session.userId
                    var setUserArea = user.setUserArea(area, sessionUserId)
                    var _addressQuery = util.getAddressQueryForChooseArea(address);
                    var areaName = _addressQuery.areaName;
                    var addressDetails = _addressQuery.addressDetails;
                    
                    return SpDeliveryAreasService.filterDeliveryAreas(area.deliveryTypeId, areaName, null, null, addressDetails).then(function (response) {
                        return $q.resolve(setUserArea).then(function () {
                            if (config.retailer.id !== area.retailerId) {
                                localStorageService.clear();
                            }
                            config.isAreaSelectedByUser = true;

                            return config.changeBranch(area.branchId, area.id, {
                                typedArea: areaName,
                                newRetailerId: area.retailerId
                            }).then(function () {
                                $rootScope.$emit('choose-area.changed');
                            });
                        });
                    });
                }

                function _setAreaByConfig() {
                    var configArea = config.getBranchArea();
                    if (configArea && checkoutCtrl.areasByName && checkoutCtrl.areasByName[configArea.name]) {
                        checkoutCtrl.areaQuery = configArea.name;
                        detailsCtrl.setDeliveryTimesFromAutocomplete({
                            option: {
                                id: checkoutCtrl.areasByName[configArea.name][0].id
                            }
                        });
                    }
                }

                function showText1HouseNumberWarning() {
                    var isIgnoreValidation

                    // TODO remove pilot check 
                    if(AddressFormService.isUseNewAddressesFeature){
                        isIgnoreValidation = [
                            _wasText1HouseNumberShown,
                            detailsCtrl.isGoogleMapDialogOpening,
                            !checkoutCtrl.detailsData.address.text1,
                            checkoutCtrl.detailsData.address.houseNumber,
                            checkoutCtrl.detailsData.deliveryMethod.id !== SP_SERVICES.DELIVERY_TYPES.DELIVERY,
                            !checkoutCtrl.isUseGMapDeliveryMethod,
                            !detailsCtrl.streetIsRequire,
                            //checkoutCtrl.detailsData.address.externalPlaceId,
                            //checkoutCtrl.detailsData.address.lat && checkoutCtrl.detailsData.address.lng,
                        ].some(function (value) {
                            return value;
                        });
                    }else{
                        var deliveryAreaPrecision = $rootScope.config.retailer.deliveryAreaPrecision;
                        isIgnoreValidation = [
                            _wasText1HouseNumberShown,
                            detailsCtrl.isGoogleMapDialogOpening,
                            !checkoutCtrl.detailsData.address.text1,
                            checkoutCtrl.detailsData.address.houseNumber,
                            //checkoutCtrl.detailsData.address.lat && checkoutCtrl.detailsData.address.lng,
                            //checkoutCtrl.detailsData.address.externalPlaceId,
                            checkoutCtrl.detailsData.deliveryMethod.id !== SP_SERVICES.DELIVERY_TYPES.DELIVERY,
                            deliveryAreaPrecision !== DELIVERY_AREA_METHODS_PRECISION.PRECISE_LOCATION && deliveryAreaPrecision !== DELIVERY_AREA_METHODS_PRECISION.CITY,
                        ].some(function (value) {
                            return value;
                        });
                    }

                    if (isIgnoreValidation) {
                        return $q.resolve();
                    }

                    var _text1 = checkoutCtrl.detailsData.address.text1;
                    var splitAddress = _text1.replace(/,/g, ' ');
                    splitAddress = splitAddress.replace(/\s+/g, ' ');
                    splitAddress = splitAddress.split(' ');

                    var hasHouseNumber = splitAddress.length >= 2 && splitAddress.some(function (word) {
                        return _houseNumberRegExp.test(word);
                    });
                    if (hasHouseNumber) {
                        return $q.resolve();
                    }

                    _wasText1HouseNumberShown = true;
                    return util.showCommonDialog({
                        content: '' +
                            '<strong>{{\'Please enter your house number\' | translate}}</strong>' +
                            ' <br /> ' +
                            '{{\'So we can assign you to the right branch\' | translate}}'
                    }).then(function () {
                        return $q.resolve();
                    });
                }

                function showSeniorCitizen() {
                    return SeniorCitizenVerificationDialog.show().then(function () {
                        detailsCtrl.isSeniorCitizen = user.data.isSeniorCitizen;

                        if (detailsCtrl.isSeniorCitizen) {
                            // run it from the detailsCtrl to run template overrides
                            detailsCtrl.setDeliveryTimes();
                        }
                    });
                }

                function filterCountryNames() {
                    if (checkoutCtrl.detailsData && checkoutCtrl.detailsData.address && checkoutCtrl.detailsData.address.country) {
                        checkoutCtrl.countryNames = util.getCountryAutocompleteOptions().filter(function (country) {
                            return country.toLowerCase().indexOf(checkoutCtrl.detailsData.address.country.toLowerCase()) !== -1;
                        });
                    }
                }


                function _checkAddressFields() {
                    checkoutCtrl.hasAddressDetails = util.checkAddressFields(checkoutCtrl.detailsData.address);
                }

                function formOnClick(evt) {
                    util.removeErrorsFromInputs();
                    if (evt.target.disabled &&
                        config.retailer.settings.autocompleteAddressField) {
                        var formElement = angular.element(document.querySelector('.checkout .tab > .details form'));
                        var serverRes = {
                            errors: [{
                                param: evt.target.name
                            }]
                        };

                        if(!config.retailer.settings.activeZipProvider.isLockedAddress) {
                            serverRes.errors[0].msg = 'not_editable';
                        } else {
                            // Checking the city only to know if the form is valid, assuming city will always be on postcode response.
                            if (!checkoutCtrl.detailsData.address.city) {
                                serverRes.errors[0].msg = 'not_editable_locked_empty';
                            } else {
                                serverRes.errors[0].msg = 'not_editable_locked';
                            }
                        }
                        if(serverRes.errors.length > 0){
                            $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_ERROR);
                        }
                        util.setServerErrorToForm(checkoutCtrl.detailsForm, formElement, {response: serverRes});
                        if (angular.element(evt.target).prop('required')) {
                            setTimeout(function () {
                                var errorElements = document.querySelectorAll('.sp-inline-error.shown');
                                // If there is already an error we need to override it with the new one
                                if (errorElements && errorElements.length) {
                                    Array.from(errorElements).forEach(function (element) {
                                        if(!config.retailer.settings.activeZipProvider.isLockedAddress) {
                                            angular.element(element).text('You cannot edit this field before entering a postcode for your address');
                                            $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_ERROR);
                                        } else {
                                            if (!checkoutCtrl.detailsData.address.city) {
                                                angular.element(element).text('Please enter your postcode and choose your address from the list');
                                                $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_ERROR);
                                            } else {
                                                angular.element(element).text('To change the address please choose again from postcode list');
                                                $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_ERROR);
                                            }
                                        }
                                    })
                                }
                            }, 0)
                        }
                    }
                }

                function openAutocompleteAddress(evt) {
                    evt.preventDefault();
                    return dialog.show({
                        templateUrl: 'template/dialogs/choose-address/index.html',
                        controller: ['$scope', function ($dialogScope) {
                            var dialogCtrl = this;
                            util.getAddressByZipCode(checkoutCtrl.detailsData.address.zipCode).then(function (result) {
                                dialogCtrl.addresses = result;
                                dialogCtrl.errorMessage = !result || !result.length;
                            });

                            $dialogScope.continue = function () {
                                if (dialogCtrl.addresses && dialogCtrl.addresses.length && !dialogCtrl.address) {
                                    return;
                                }

                                delete dialogCtrl.address.description;
                                var fullAddress = [dialogCtrl.address.text1];
                                if (dialogCtrl.address.locality) {
                                    fullAddress.push(dialogCtrl.address.locality);
                                }
                                dialogCtrl.address.text1 = fullAddress.join(', ');
                                checkoutCtrl.detailsData.address = Object.assign(checkoutCtrl.detailsData.address, dialogCtrl.address);

                                _checkAddressFields();
                                util.removeErrorsFromInputs();
                                detailsCtrl.setDeliveryTimes();
                                dialog.hide();
                            };
                            $dialogScope.cancel = function () {
                                dialog.hide();
                            };
                        }],
                        controllerAs: 'dialogCtrl',
                        styleClass: 'choose-address',
                        ariaLabelledby: 'choose_address_dialog_title',
                    })
                }

                /**
                 * Get coupon list
                 * @private
                 * @param {number[]} couponIds coupon id list
                 * @returns Promise<any>
                 */
                function _getCoupons(couponIds) {
                  return api.request({
                    method: 'GET',
                    url: '/v2/retailers/:rid/branches/:bid/users/:uid/coupons/' + couponIds.join(','),
                    params: {
                      extended: true,
                      countonly: false,
                    },
                  })
                }

                /**
                 * Show irrelevant sales dialog
                 * @private
                 * @param {boolean} isNewPromotionDesignEnabled
                 * @param {any} lineTypes
                 * @param {any} expiredInfo
                 * @param {any} irrelevantSales
                 * @returns Promise<any>
                 */
                function _showIrrelevantSalesDialog(isNewPromotionDesignEnabled, lineTypes, expiredInfo, irrelevantSales, skipDialogSpecial) {
                    return dialog.show({
                        templateUrl: isNewPromotionDesignEnabled ? 'template/dialogs/new-irrelevant-sales/index.html' : 'template/dialogs/irrelevant-sales/index.html',
                        styleClass: isNewPromotionDesignEnabled ? 'cart-summary-dialog-new notice-sale-date-new' : 'cart-summary-dialog notice-sale-date',
                        controller: [
                            '$scope',
                            function ($scope) {
                                $scope.lineTypes = lineTypes;
                                $scope.deliveryDate = checkoutCtrl.detailsData.delivery.times.date;
                                $scope.totalPriceUpdate = (skipDialogSpecial && $rootScope.cart.total.finalPriceForView) || (!skipDialogSpecial && $rootScope.cart.total.finalPriceForViewPotential);
                                $scope.irrelevantSellDateObj = null; // for old Promotion display
                                $scope.irrelevantSalesCount = 0;// for old Promotion display
                                $scope.displayChoosenDateButton = true;

                                /* ─────────── invalid sales handlers ─────────── */
                                var otherIrrelevantCount = 0;
                                var invalidSalesHandlers = {
                                    sellDates: function (obj) {
                                        obj.items.forEach(deductPrice);
                                        $scope.irrelevantSellDateObj = obj;
                                    },
                                    cateringProduct: function (obj) {
                                        obj.items.forEach(deductPrice);
                                        $scope.irrelevantCateringProductObj = obj;
                                    },
                                    _default: function (obj) {
                                        otherIrrelevantCount += obj.items.length;
                                    }
                                };

                                _setItems();

                                /* helper extracted – eliminates duplicated code */
                                function deductPrice(line) {                           // NEW
                                    var price = skipDialogSpecial ? line.finalPriceForView
                                        : line.finalPriceForViewPotential || 0;
                                    $scope.totalPriceUpdate -= Number(price || 0);
                                }

                                function applyInvalidSalesHandlers(key, obj) {
                                    var handler = invalidSalesHandlers[key] || invalidSalesHandlers._default;
                                    handler(obj);
                                }


                                function constructTitle(field, idx, count, type) {
                                    var titleConfig = {
                                        main: {
                                            0: {
                                                singular: 'Please notice, the following products are not available on this chosen time',
                                                plural: 'Please notice, the following products are not available on this chosen time',
                                            },
                                            1: {
                                                singular: 'Please notice, the {type} displayed below, will not be valid for this chosen time',
                                                plural: 'Please notice, the expiration of these {count} {type} will not be valid for this chosen time',
                                            },
                                            2: {
                                                singular: 'The coupon displayed below, will not be valid for this chosen time',
                                                plural: 'These {count} coupons will not be valid for this chosen time',
                                            },
                                            3: {
                                                singular: 'The following product require more preparation time and won\'t be ready for your selected time slot',
                                                plural: 'The following products require more preparation time and won\'t be ready for your selected time slot',
                                            }
                                        },
                                        sub: {
                                            0: {
                                                singular: 'If you continue, they will be removed from your cart',
                                                plural: 'If you continue, they will be removed from your cart',
                                            },
                                            1: {
                                                singular: 'This product will be charged the regular price, promotion will not be applied',
                                                plural: 'These items will be charged at their regular price',
                                            },
                                            2: {
                                                singular: 'This product will be charged the regular price, promotion will not be applied',
                                                plural: 'These items will be charged at their regular price',
                                            },
                                            3: {
                                                singular: 'If you continue, they will be removed from your cart',
                                                plural: 'If you continue, they will be removed from your cart',
                                            }
                                        },
                                    };
                                    var translatedType = translateFilter(type) ? translateFilter(type).toLowerCase() : '';
                                    var amountField = count === 1 ? 'singular' : 'plural';
                                    var title = titleConfig[field][idx][amountField];
                                    if (count === 1) {
                                        // In case, we only have a coupon or special, we use immediately two sentences:
                                        // + the special displayed below, will expire on the date you are supposed to receive your order
                                        // + the coupon displayed below, will expire on the date you are supposed to receive your order
                                        // ==> we will translate whole sentence
                                        title = title.replace('{type}', type);
                                    }
                                    return translateFilter(title).replace('{type}', translatedType).replace('{count}', count);
                                }

                                function _setItems() {
                                    var displayLines = [];
                                    var idx = 0;
                                    var expiredPromotions = [];
                                    Object.keys(expiredInfo).forEach(function (key) {
                                        var obj = expiredInfo[key] || {};
                                        if (obj.items && obj.items.length) {
                                            var count = obj.items.length;
                                            var type = count === 1 ? key : key + 's';
                                            obj.mainTitle = constructTitle('main', idx, count, type);
                                            obj.subTitle = constructTitle('sub', idx, count, type);
                                            displayLines.push(obj);

                                            applyInvalidSalesHandlers(key, obj);
                                            
                                            obj.items.forEach(function(line){
                                                expiredPromotions.push(line.description);
                                            });
                                        }
                                        idx++;
                                    })

                                    $scope.irrelevantSalesCount = otherIrrelevantCount;
                                    $scope.displayLines = isNewPromotionDesignEnabled ? displayLines : irrelevantSales;
                                    $rootScope.$emit($rootScope.SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_EXPIRED_PROMOTION_POP_UP_SHOWN_AT_CHECKOUT, {
                                        expiredPromotions: expiredPromotions
                                      });
                                    $scope.data = { analyticsLabel: '' };
                                }
                            },
                        ],
                    });
                }

                function openGoogleMapDialog() {
                    detailsCtrl.isGoogleMapDialogOpening = true;
                    var _defaultLocation = AddressFormService.getDefaultLocation(checkoutCtrl.detailsData.address);

                    dialog.show({
                        templateUrl: 'template/dialogs/google-map-dialog/index.html',
                        controller: 'GoogleMapDialogCtrl as googleMapDialogCtrl',
                        locals: {
                            defaultLocation: _defaultLocation
                        }
                    }).then(function (selectedAddress) {
                        if (!selectedAddress) {
                            return;
                        }

                        _disableAllDropPinFields();
                        checkoutCtrl.isDropPinAddress = true;
                        checkoutCtrl.isDropPinAddressNotDetected = !selectedAddress.hasHouseNumberAndRoute;
                        _setOrInitValueForAddrField('isShowEditAddress', !selectedAddress.hasHouseNumberAndRoute);
                        _setOrInitValueForAddrField('isDisabledAddressField', !selectedAddress.hasHouseNumberAndRoute);

                        var _address = AddressFormService.onDroppedPinAddress(selectedAddress);
                        angular.extend(checkoutCtrl.detailsData.address, _address);
                        angular.extend(detailsCtrl.backupAddress, checkoutCtrl.detailsData.address);

                        
                        var text = (_address.text1 || _address.street  || '') + ' ' + (_address.houseNumber || '') + ' ' + (_address.city || '');
                        // Emit ECOM-17455 Drop Pin Used event
                        $rootScope.$emit($rootScope.SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_DROP_PIN_USED, {
                            addressPined: text.trim()
                        });

                        // If users select a valid address, we will consider it as suggested address and remove validation
                        $scope.$emit('checkout.details.hideFormError', {
                            hiddenFields: ['city', 'text1', 'zipCode', 'street', 'houseNumber'],
                        });

                        detailsCtrl.setDeliveryTimes();
                        if(selectedAddress.zipCode){
                            detailsCtrl.onZipCodeBlur();
                        }
                    }).finally(function () {
                        $timeout(function () {
                            /**
                             * ECOM-6403: Just temporally solution for Prutah template
                             * After closing dialog, the address input is automatically focused and blurred. This behavior affects unrecognized address behavior
                             */
                            detailsCtrl.isGoogleMapDialogOpening = false;
                        }, 0);
                    });
                }

                // run setDeliveryTimes on event
                $scope.$on('checkoutDetails.setDeliveryTimes', function (event, data) {
                    // run it from the detailsCtrl to run template overrides
                    detailsCtrl.setDeliveryTimes(data);
                });

                // prevent go to app.checkout.summary state if !_validateForm()
                util.currentScopeListener($scope, $rootScope.$on('$stateChangeStart', function (event, to) {
                    if (to.name === 'app.checkout.summary' && !detailsCtrl._validateForm()) {
                        event.preventDefault();
                        return false;
                    }
                }));

                /**
                 * @param {string} field field of address
                 * @returns { string | null }
                 */
                function _extractAddressField(field) {
                    return AddressFormService.extractAddressField(field, checkoutCtrl.detailsData.address);
                }

                function _getInternalCities(cityQuery) {
                    return AddressService.getInternalCities(cityQuery);
                }

                function _getCitiesFromGoogleMapApi(cityQuery) {
                    return AddressService.getCitiesFromGoogleMapApi(cityQuery);
                }

                function _getZipCodeFromGoogleMapApi(zipCode) {
                    return AddressService.getZipCodeFromGoogleMapApi(zipCode, '', zipCode, true);
                }

                function getAddressAutoCompleteOptions(fieldName, isForce) {
                    if (!detailsCtrl.isRunAddressAutoComplete && !isForce) {
                        return $q.resolve([]);
                    }
                    
                    var addressQuery = _extractAddressField(fieldName);
                    var _addressFilteringMode = AddressFormService.isUseNewAddressesFeature && checkoutCtrl.enableAddressFiltering && AddressFormService.addressFiltering ? AddressFormService.addressFiltering : null;

                    return AddressService.getAddressAutoCompleteOptions(addressQuery, {
                        addressFilteringMode:  _addressFilteringMode,
                        placeId: checkoutCtrl.detailsData.address.placeId,
                        city: checkoutCtrl.detailsData.address.city,
                        zipCode: checkoutCtrl.detailsData.address.zipCode,
                        languageId: $rootScope.config.language.id
                    }).then(function (addresses) {
                        detailsCtrl.suggestedAddresses = addresses;
                        detailsCtrl.addressCompletedMethod = 'AutoComplete';
                        return addresses;
                    })
                }

                function onAddressChange() {
                    if (detailsCtrl.isAddressVerificationEnabled) {
                        $scope.$emit('checkout.details.hideFormError', {
                            hiddenFields: ['text1'],
                        });
                    }
                }

                function onAddressBlur(event, fieldName) {
					if (_isClickToSuggestion(event)) return;

					var validatedResult = AddressFormService.onAddressBlur(
						fieldName,
                        detailsCtrl.backupAddress,
						checkoutCtrl.detailsData.address,
						detailsCtrl.suggestedAddresses
					);
					if (validatedResult) {
						if (!validatedResult.isValid) {
							$scope.$emit('checkout.details.setFormError', fieldName);
						} else {
							$scope.$emit('checkout.details.hideFormError', {
								hiddenFields: [fieldName]
							});

							if (validatedResult.suggestion) {
								onAddressChosen({option: validatedResult.suggestion}, fieldName);
							}
						}
					}

					_handleOnLocationBlur(fieldName);
					detailsCtrl.setDeliveryTimes();
				}

                function onHouseNumberBlur() {
                    var fieldName = 'houseNumber';

                    var _isAddressChanged = _isLocationChanged(fieldName);
                    if (_isAddressChanged) {
                        AddressFormService.cleanAddressDataBaseOnRetailerConfig(checkoutCtrl.detailsData.address);
                    }

                    detailsCtrl.setDeliveryTimes();
                }

                function onAddressChosen($event, fieldName) {
                    var addressComponent = $event && $event.option && $event.option.component;
                    if (addressComponent) {
                        return AddressFormService.onAddressChosen(addressComponent.externalPlaceId, $rootScope.config.language.id).then(function (address) {
                            detailsCtrl.isRunAddressAutoComplete = false;
                            angular.extend(checkoutCtrl.detailsData.address, address);
                            angular.extend(detailsCtrl.backupAddress, address);
                            $scope.$emit('checkout.details.hideFormError', {
                                hiddenFields: ['city', 'text1', 'zipCode', 'street', 'houseNumber'],
                            });
                        }).finally(function () {
                            getAddressAutoCompleteOptions(fieldName, true);
                            onAddressBlur(null, fieldName);
                        });
                    }
                }

                /**
                 * @param {'city' | 'address' | 'zip code'} addressType
                 * @param {string} value
                 * @param {any[]} suggestions suggestedCities | suggestedAddresses
                 * @returns boolean
                 */
                function _isExistedInSuggestions(addressType, value, suggestions) {
                    return AddressFormService.isExistedInSuggestions(checkoutCtrl.detailsData.address, addressType, value, suggestions);
                }

                /**
                 * @param {'city' | 'text1' | 'country'} ctrlName
                 * @return {void}
                 */
                function _showErrorTooltip(ctrlName) {
                    var formElement = _getFormElement();
                    if (formElement) {
                        var ctrl = angular.element(formElement.querySelector('[name=' + ctrlName + ']'));
                        if (ctrl) {
                            ctrl.triggerHandler('blur');
                        }
                    }
                }

                function _deleteDeliveryAreaFields() {
                    delete checkoutCtrl.areaQuery;
                    delete checkoutCtrl.areasByName;
                    delete checkoutCtrl.areasById;
                    delete checkoutCtrl.areasOptions;
                    _resetTimesOptions();
                }

                function _verifyCityAndAddress() {
                    return AddressFormService.verifyIsSuggestedValue(
                        checkoutCtrl.detailsData.address, 
                        checkoutCtrl.isDropPinAddress, 
                        detailsCtrl.suggestedAddresses, 
                        detailsCtrl.suggestedCities, 
                        detailsCtrl.suggestedZipCodes
                    );
                }

                function onAddressInputKeyDown() {
                    if (detailsCtrl.isAddressVerificationEnabled) {
                        detailsCtrl.isRunAddressAutoComplete = true;
                    }
                }

                /**
                 * @param {'text1' | 'city' | 'country'} field
                 * @returns {boolean}
                 */
                function _isLocationChanged(field) {
                    return AddressFormService.isLocationChanged(field, detailsCtrl.backupAddress, checkoutCtrl.detailsData.address)
                }

                function onCountryBlur() {
                    $timeout(function () {
                        _handleOnLocationBlur('country');
                    }, 300);
                }

                /**
                 * Handle onLocationBlur event
                 * @param {'country' | 'city' | 'text1'} emittedField
                 */
                function _handleOnLocationBlur(emittedField) {
                    AddressFormService.handleOnLocationBlur(emittedField, detailsCtrl.backupAddress, checkoutCtrl.detailsData.address, checkoutCtrl.previousFullDeliveryAddress.address);
                }

                /**
                 * Init state
                 * @param {string} field
                 * @param {any} value
                 * @param {any} initialValue
                 */
                function _setOrInitValueForAddrField(field, value, initialValue) {
                    AddressFormService.setOrInitValueForAddressField(checkoutCtrl.detailsData.address, field, value, initialValue);
                }

                function editUnrecognizedAddress() {
                    if (!checkoutCtrl.detailsData.address.isDisabledAddressField) {
                        return;
                    }

                    var text1InputRef = AddressFormService.isUseNewAddressesFeature ? document.getElementById("text1") : document.querySelector("[name='text1']");
                    if (text1InputRef) {
                        checkoutCtrl.detailsData.address.isDisabledAddressField = false;
                        $timeout(function () {
                            text1InputRef.focus();
                        }, 0);
                    }
                }

                function isShowAddressField(fieldName){
                return AddressFormService.isShowAddressField(fieldName, checkoutCtrl.isDropPinAddress, checkoutCtrl.isDropPinAddressNotDetected);
                }

                function isDisableAddressField(filteringMode){
                    return AddressFormService.isDisableAddressField(filteringMode, checkoutCtrl.detailsData.address);
                }

                function isDropPinRequiredStreetAndHouseNumber(){
                    return AddressFormService.isDropPinRequiredStreetAndHouseNumber(checkoutCtrl.isDropPinAddress, checkoutCtrl.isDropPinAddressNotDetected);
                }

                function editDropPinAddressField(elementSelector, field){
                    var _element = document.querySelector(elementSelector);
                    if (_element) {
                        checkoutCtrl.dropPinDisableFields[field] = false;

                        $timeout(function () {
                            _element.focus();
                        }, 0);
                    }
                }

                function onDropPinAddressFieldBlur(){
                    _disableAllDropPinFields();
                    detailsCtrl.setDeliveryTimes()
                }

                function _isClickToSuggestion(event){
                    // if click to choose suggestion, disable blur event temporarily
                    var _parentTargetClickId = event && event.relatedTarget && event.relatedTarget.parentElement ? event.relatedTarget.parentElement.id : null;
                    if (_parentTargetClickId && _parentTargetClickId.startsWith('sp_autocomplete_')) {
                        return true;
                    }
                    return false;
                }
                
                function getAddressFieldLabel(fieldName, options) {
                    return AddressFormService.getAddressFieldLabel(fieldName, $rootScope.config.language.id, options);
                }

                function getAddressFormFieldSettings(fieldName) {
                return AddressFormService.getAddressFormFieldSettings(fieldName);
                }

                function _disableAllDropPinFields() {
                    AddressFormService.disableAllDropPinFields(checkoutCtrl.dropPinDisableFields);
                }

                function getDropPinClarifyMessage() {
                    return AddressFormService.getDropPinClarifyMessage($rootScope.config.language.culture);
                }

                function _init() {
                    try {
                        util.getCheckoutPaymentReceiptPromotions()
                            .then(function(response) {
                                if (!response) {
                                    console.error('Error initializing checkout details: No response from getCheckoutPaymentReceiptPromotions');
                                    return;
                                }

                                var isDelivery = checkoutCtrl.detailsData.deliveryMethod.id === SP_SERVICES.DELIVERY_TYPES.DELIVERY;
                                detailsCtrl.rawCkoutPromotionConfig = util.deepClone(response);
                                detailsCtrl.checkoutPromotionSettings = util
                                    .processConfigPromotions(
                                        detailsCtrl.rawCkoutPromotionConfig, 
                                        isDelivery
                                    );
                            });
                    } catch (error) {
                        console.error('Error initializing checkout details:', error);
                    }
                }

                $rootScope.$on('choose-area.changed', function () {
                    if(checkoutCtrl.detailsData.deliveryMethod.id === SP_SERVICES.DELIVERY_TYPES.DELIVERY) {
                        util.setChangeBranchSavedAddress(checkoutCtrl.detailsData.address);
                    }
                });

                $scope.$on('checkout.details.setFormError', function (_, errorField) {
                    var message = AddressFormService.getFormFieldErrorMessage(errorField);
                    detailsCtrl.formErrorCtrl[errorField] = true;
                    _setFormError(message);
                });

                $scope.$on('checkout.details.hideFormError', function (_, emitterData) {
                    angular.forEach(emitterData.hiddenFields, function (field) {
                        detailsCtrl.formErrorCtrl[field] = false;
                    });

                    var _errorKey;
                    if(detailsCtrl.formErrorCtrl.text1) { _errorKey = 'text1'; }
                    else if(detailsCtrl.formErrorCtrl.city) { _errorKey = 'city'; }
                    else if(detailsCtrl.formErrorCtrl.zipCode) { _errorKey = 'zipCode'; }

                    if(_errorKey){
                        $scope.$emit('checkout.details.setFormError', _errorKey);
                        return;
                    }

                    _setFormError('');
                });

                $scope.$watch('checkoutCtrl.detailsData.deliveryMethod', function () {
                    var deliveryMethodId = checkoutCtrl.detailsData.deliveryMethod.id;
                    var isEnable = config.retailer.settings.isAddressVerificationEnabled && config.retailer.settings.isAddressVerificationEnabled === 'true';
                    detailsCtrl.isAddressVerificationEnabled = deliveryMethodId !== SP_SERVICES.DELIVERY_TYPES.PICKUP && isEnable && checkoutCtrl.isUseGMapDeliveryMethod;
                    $scope.$emit('checkout.details.hideFormError', {
                        hiddenFields: ['city', 'text1'],
                    });
                    var isDelivery = deliveryMethodId === SP_SERVICES.DELIVERY_TYPES.DELIVERY;
                    detailsCtrl.checkoutPromotionSettings = util.processConfigPromotions(detailsCtrl.rawCkoutPromotionConfig, isDelivery);
                });

                $scope.$watch('config.language.id', function(newValue, oldValue) {
                    if (detailsCtrl.formErrorMessage) {
                        _setFormError(detailsCtrl.formErrorMessage, true);
                    }

                    // Skip on first initialization
                    if (oldValue === undefined || oldValue === newValue) {
                        return;
                    }

                    var languagePreferences = _getSubstitutePreferencesConfig();
                    if (languagePreferences) {
                        detailsCtrl.substitutePreferences = languagePreferences.options || [];
                        detailsCtrl.substitutePreferencesTitle = languagePreferences.title;
                    }
                });
                
                util.currentScopeListener($scope, $scope.$watch('checkoutCtrl.detailsData.delivery.time', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                     
                        var deliveryPrice = util.getDataByPath(newValue, 'deliveryProduct.branch.regularPrice') || 0;
                        var slotAvailable = util.getDataByPath(newValue, 'isActive');
                        var object = {
                            selectedStoreId: checkoutCtrl.area.id,
                            slotDate: util.getDataByPath(checkoutCtrl, 'detailsData.delivery.times.date'),
                            selectedTimeWindow: slotAvailable ? util.getDataByPath(newValue, 'newFrom') + ' - ' + util.getDataByPath(newValue, 'newTo') : '',
                            slotType: checkoutCtrl.detailsData.deliveryMethod.id,
                            deliveryFee: deliveryPrice,
                            isSlotAvailable: slotAvailable,
                            earlyDeliveryPreferenceSet: util.getDataByPath(checkoutCtrl, 'detailsData.delivery.times.asap') || false
                        };
                        $rootScope.$emit($rootScope.SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_DELIVERY_SLOT_CHANGED, object);   
                    }
                }));
            }])
        //move to prutah template when javascript per template is supported;
        .controller('PrutahCheckoutDetailsTabCtrl', ['$scope', '$rootScope', '$document', '$filter', 'Util', 'SP_SERVICES', 'Config', function ($scope, $rootScope, $document, $filter, Util, SP_SERVICES, config) {
            var detailsCtrl = $scope.detailsCtrl,
                checkoutCtrl = $scope.checkoutCtrl,
                _translateFilter = $filter('translate'),
                _scrolledToTimes = false,
                _baseSetDeliveryTimes = detailsCtrl.setDeliveryTimes;

            detailsCtrl.setDeliveryTimes = setDeliveryTimes;
            detailsCtrl._validateForm = _validateForm;

            function setDeliveryTimes(options) {
                return detailsCtrl
                    .showText1HouseNumberWarning()
                    .then(function () {
                        return _baseSetDeliveryTimes(options)
                            .then(function () {
                                if (detailsCtrl.validateAddress()
                                    && checkoutCtrl.timesOption
                                    && !_scrolledToTimes
                                    && checkoutCtrl.detailsData.deliveryMethod.id !== SP_SERVICES.DELIVERY_TYPES.PICKUP) {
                                    _scrolledToTimes = true;
                                    _scrollToTimes();
                                }
                            });
                    }, function () {
                        document.querySelector('#text1').focus();
                    })
            }

            function _scrollToTimes() {
            $document.scrollToElement(document.getElementById('content'), 120, 1000);
            }

            function _validateForm() {
                var formElement = angular.element(document.querySelector('.checkout .tab > .details form'));

                if (checkoutCtrl.detailsForm.$invalid) {
                    Util.setFirstErrorInput(formElement);
                    
                    // Track required field errors for invalid form
                    angular.forEach(checkoutCtrl.detailsForm, function(field, fieldName) {
                        if (field && field.$error && field.$error.required && fieldName.indexOf('$') !== 0) {
                            $rootScope.$emit($rootScope.SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_ADDRESS_FORM_ERROR_DISPLAYED, {
                                fieldWithError: fieldName === 'text1' ? 'address' : fieldName,
                                errorType: 'Required Field'
                            });
                        }
                    });
                    
                    return Promise.resolve(false);
                }

                return detailsCtrl.validatePhone().then(function (isPhoneValid) {
                    if (checkoutCtrl.detailsData.mobilePhone.phoneNumber) {
                        if (parseInt(checkoutCtrl.detailsData.mobilePhone.phoneNumber.substring(0, 4)) === 0 || !isPhoneValid) {
                            //== Mark element with validation error
                            Util.setServerErrorToForm(checkoutCtrl.detailsForm, formElement, {
                                response: {
                                    errors: [{
                                        param: 'phone',
                                        msg: 'number'
                                    }]
                                }
                            });

                            //== go to element and set focus to it
                            document.querySelector('.details form [name="phone"]').focus();
                            return false;
                        }
                    }

                    if (!checkoutCtrl.detailsData.delivery || !checkoutCtrl.detailsData.delivery.time) {
                        if (checkoutCtrl.timesOption) {
                            _scrollToTimes();
                            detailsCtrl.deliveryTimeError = _translateFilter('Please choose ' + (checkoutCtrl.detailsData.deliveryMethod.id === SP_SERVICES.DELIVERY_TYPES.DELIVERY ? 'delivery' : 'pickup') + ' time');
                        } else {
                            Util.showCommonDialog({
                                title: '{{\'Delivery Details\' | translate}}',
                                content: '{{\'Sorry, currently we do not deliver to this area, for further inquiries call our customer service\' | translate}}',
                            });
                        }

                        return false;
                    }

                    Util.setServerErrorToForm(checkoutCtrl.detailsForm, formElement, '');
                    return true;
                });

            }
        }])
        //move to kikar template when javascript per template is supported;
        .controller('KikarCheckoutDetailsTabCtrl', ['$scope', '$document', '$filter', 'Util', 'SP_SERVICES', 'Config', function ($scope, $document, $filter, Util, SP_SERVICES, config) {
            var detailsCtrl = $scope.detailsCtrl,
                checkoutCtrl = $scope.checkoutCtrl,
                _translateFilter = $filter('translate'),
                _scrolledToTimes = false,
                _baseSetDeliveryTimes = detailsCtrl.setDeliveryTimes;

            detailsCtrl.setDeliveryTimes = setDeliveryTimes;
            detailsCtrl._validateForm = _validateForm;

            function setDeliveryTimes(options) {
                return detailsCtrl
                    .showText1HouseNumberWarning()
                    .then(function () {
                        return _baseSetDeliveryTimes(options).then(function () {
                            if (detailsCtrl.validateAddress()
                                && checkoutCtrl.timesOption
                                && !_scrolledToTimes
                                && checkoutCtrl.detailsData.deliveryMethod.id !== SP_SERVICES.DELIVERY_TYPES.PICKUP) {
                                _scrolledToTimes = true;
                                _scrollToTimes();
                            }
                        });
                    }, function () {
                        document.querySelector('#text1').focus();
                    })
            }

            function _scrollToTimes() {
                $document.scrollToElement(document.querySelector('.details form .delivery-details'), 120, 1000);
            }

            function _validateForm() {
                var formElement = angular.element(document.querySelector('.checkout .tab > .details form'));


                if (checkoutCtrl.detailsForm.$invalid) {
                    Util.setFirstErrorInput(formElement);
                    return Promise.resolve(false);
                }

                return detailsCtrl.validatePhone().then(function (isPhoneValid) {
                    //== check if Phone Number's country code is zero - "google-libphonenumber" library returning an error if it is
                    if (checkoutCtrl.detailsData.mobilePhone.phoneNumber) {
                        if (parseInt(checkoutCtrl.detailsData.mobilePhone.phoneNumber.substring(0, 4)) === 0 || !isPhoneValid) {
                            //== Mark element with validation error
                            Util.setServerErrorToForm(checkoutCtrl.detailsForm, formElement, {
                                response: {
                                    errors: [{
                                        param: 'phone',
                                        msg: 'number'
                                    }]
                                }
                            });

                            //== go to element and set focus to it
                            document.querySelector('.details form [name="phone"]').focus();
                            return false;
                        }
                    }


                    if (!checkoutCtrl.detailsData.delivery || !checkoutCtrl.detailsData.delivery.time) {
                        if (checkoutCtrl.timesOption) {
                            _scrollToTimes();
                            detailsCtrl.deliveryTimeError = _translateFilter('Please choose ' + (checkoutCtrl.detailsData.deliveryMethod.id === SP_SERVICES.DELIVERY_TYPES.DELIVERY ? 'delivery' : 'pickup') + ' time');
                        } else {
                            Util.showCommonDialog({
                                title: '{{\'Delivery Details\' | translate}}',
                                content: '{{\'Sorry, currently we do not deliver to this area, for further inquiries call our customer service\' | translate}}',
                            });
                        }

                        return false;
                    }
                    Util.setServerErrorToForm(checkoutCtrl.detailsForm, formElement, '');
                    return true;
                });
            }
        }]);
})(angular, app);
